"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3063],{

/***/ 58562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var theme_sub_menu__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66084);
/* harmony import */ var translations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99408);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15313);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var redux_api_action_filters__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93103);
/* harmony import */ var redux_api_reselect_filters__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45257);
/* harmony import */ var redux_api_reselect_profile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95293);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32016);









function AnalyticsSubMenu(param) {
    var activeKey = param.activeKey;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var languageCode = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return state.config;
    }).languageCode;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)(), push = ref.push, query = ref.query;
    var ref1 = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(redux_api_reselect_filters__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z), dataType = ref1.dataType, compare = ref1.compare, dateRange = ref1.dateRange, dateFrom = ref1.dateFrom, dateTo = ref1.dateTo, filters = ref1.filters, terms = ref1.terms, filtersData = ref1.filtersData, termsData = ref1.termsData;
    var ref2 = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(redux_api_reselect_profile__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z), _payload = ref2.payload, company = _payload.company, analytics_type = _payload.analytics_type, hasPROPlan = _payload.hasPROPlan;
    var handleDataTypeChange = function(dataType) {
        return function() {
            dispatch((0,redux_api_action_filters__WEBPACK_IMPORTED_MODULE_8__/* .changeDataTypeFilter */ .u2)(dataType));
            dispatch((0,redux_api_action_filters__WEBPACK_IMPORTED_MODULE_8__/* .resetChanged */ .VS)());
            var newQuery = {
                compare: encodeURI(compare),
                dataType: encodeURI(dataType),
                dateRange: encodeURI(dateRange),
                dateFrom: encodeURI(dateFrom),
                dateTo: encodeURI(dateTo),
                filters: encodeURI(filters),
                terms: encodeURI(terms),
                filtersData: encodeURI(filtersData),
                termsData: encodeURI(termsData)
            };
            push({
                pathname: "/analytics",
                query: newQuery
            });
        };
    };
    var options = [
        {
            key: "panoramic",
            title: (analytics_type === null || analytics_type === void 0 ? void 0 : analytics_type.match(/split/i)) ? translations__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[languageCode].trend : translations__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[languageCode].revenues,
            onClick: handleDataTypeChange((analytics_type === null || analytics_type === void 0 ? void 0 : analytics_type.match(/split/i)) ? "temporary_data" : "aggregated_data"),
            color: "primary_300"
        },
        {
            key: "usage",
            title: translations__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[languageCode].usage,
            onClick: handleDataTypeChange("usage_data")
        },
        {
            key: "data-stores",
            title: translations__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[languageCode]["Data & Stores"],
            href: "/analytics/data-stores"
        }, 
    ];
    if (analytics_type === null || analytics_type === void 0 ? void 0 : analytics_type.match(/split/i)) {
        options.splice(1, 0, {
            key: "confirmed",
            title: translations__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[languageCode].realdata,
            onClick: handleDataTypeChange("real_data"),
            color: "primary_300"
        });
    }
    if (company && (company === null || company === void 0 ? void 0 : company.code) === "SL_US" && !hasPROPlan) options.push({
        key: "upgradeToPro",
        title: translations__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[languageCode].upgradeToPro,
        href: "https://www.streetlib.com/pricing/",
        color: "orange_400"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(theme_sub_menu__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        activeKey: dataType !== "usage_data" ? activeKey : "usage",
        options: options
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AnalyticsSubMenu);


/***/ }),

/***/ 42739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ filters; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var index_esm = __webpack_require__(79352);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 12 modules
var dist_index_esm = __webpack_require__(32016);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js
var theme_get_dist_index_esm = __webpack_require__(50056);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/lib/calculate-range.js
var calculate_range = __webpack_require__(55787);
;// CONCATENATED MODULE: ./src/lib/filters-from-query.js





var filtersFromQuery = function(query) {
    var filters = query.filters, terms = query.terms, dateFrom = query.dateFrom, dateTo = query.dateTo, filtersData = query.filtersData, termsData = query.termsData, rest = (0,_object_without_properties/* default */.Z)(query, [
        "filters",
        "terms",
        "dateFrom",
        "dateTo",
        "filtersData",
        "termsData"
    ]);
    var defaultDates = (0,calculate_range/* default */.Z)();
    var others = {};
    var filtersDataObj = {};
    var termsDataObj = {};
    if (filters) {
        var splitedFilters = filters.split(",");
        splitedFilters.forEach(function(filter) {
            var splitedFilter = filter.split("=");
            if (splitedFilter.length !== 2) return;
            var filterType = decodeURIComponent(splitedFilter[0]);
            var filterValue = decodeURIComponent(splitedFilter[1]);
            var isExclusive = filterValue.startsWith("-");
            var cleanValue = isExclusive ? filterValue.substring(1) : filterValue;
            var value = "".concat(filterType, "=").concat(cleanValue);
            others = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, others), // La chiave deve combaciare con quella generata in handleChangeOtherFilter
            // (`${type}-${value}`), altrimenti il merge con filtersData fallisce e si
            // creano entry senza `value`.
            (0,_define_property/* default */.Z)({}, JSON.stringify("".concat(filterType, "-").concat(value)), {
                type: filterType,
                value: value,
                isExclusive: isExclusive
            }));
        });
    }
    var termsParams = {};
    if (terms) {
        var splitedTerms = terms.split(",");
        splitedTerms.forEach(function(term) {
            var splitedTerm = term.split("=");
            if (splitedTerm.length !== 2) return;
            var termType = decodeURIComponent(splitedTerm[0]);
            var termValue = decodeURIComponent(splitedTerm[1]);
            var isExclusive = termValue.startsWith("-");
            var cleanValue = isExclusive ? termValue.substring(1) : termValue;
            var value = "".concat(termType, "=").concat(cleanValue);
            termsParams = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, termsParams), // Stessa chiave generata in handleChangeTermFilter (`${type}-${value}`).
            (0,_define_property/* default */.Z)({}, JSON.stringify("".concat(termType, "-").concat(value)), {
                type: termType,
                value: value,
                isExclusive: isExclusive
            }));
        });
    }
    if (filtersData) {
        filtersDataObj = JSON.parse(decodeURIComponent(filtersData));
        // Merge filtersData (label, color, type) with others (value, isExclusive from filters)
        Object.keys(filtersDataObj).forEach(function(key) {
            if (others[key]) {
                // Merge the data from filtersData into the object from filters
                others[key] = (0,_object_spread/* default */.Z)({}, others[key], filtersDataObj[key]);
            } else if (filtersDataObj[key] && filtersDataObj[key].value) {
                // Only adopt orphan entries that still carry a `value`; entries without
                // it would crash the filters selector (filter.value.split).
                others[key] = filtersDataObj[key];
            }
        });
    }
    if (termsData) {
        termsDataObj = JSON.parse(decodeURIComponent(termsData));
        // Merge termsData (label, color, type) with termsParams (value, isExclusive from terms)
        Object.keys(termsDataObj).forEach(function(key) {
            if (termsParams[key]) {
                // Merge the data from termsData into the object from terms
                termsParams[key] = (0,_object_spread/* default */.Z)({}, termsParams[key], termsDataObj[key]);
            } else if (termsDataObj[key] && termsDataObj[key].value) {
                // Only adopt orphan entries that still carry a `value` (see filters above).
                termsParams[key] = termsDataObj[key];
            }
        });
    }
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        others: others,
        terms: termsParams,
        dateFrom: dateFrom || defaultDates[0],
        dateTo: dateTo || defaultDates[1],
        filtersData: filtersDataObj,
        termsData: termsDataObj
    });
};
/* harmony default export */ var filters_from_query = (filtersFromQuery);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(15313);
// EXTERNAL MODULE: ./src/redux/action/filters.js
var action_filters = __webpack_require__(93103);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./src/redux/reselect/config.js
var config = __webpack_require__(57708);
// EXTERNAL MODULE: ./src/redux/reselect/profile.js
var profile = __webpack_require__(95293);
// EXTERNAL MODULE: ./src/redux/reselect/filters.js
var reselect_filters = __webpack_require__(45257);
// EXTERNAL MODULE: ./src/hooks/index.js
var hooks = __webpack_require__(85480);
// EXTERNAL MODULE: ./src/theme/buttons/btn-border.js
var btn_border = __webpack_require__(9246);
// EXTERNAL MODULE: ./src/theme/buttons/ghost.js
var ghost = __webpack_require__(17227);
;// CONCATENATED MODULE: ./src/theme/icons/tune.js


var tune = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "19",
        viewBox: "0 0 18 19",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M0 14.3638V16.3638H6V14.3638H0ZM0 2.36377V4.36377H10V2.36377H0ZM10 18.3638V16.3638H18V14.3638H10V12.3638H8V18.3638H10ZM4 6.36377V8.36377H0V10.3638H4V12.3638H6V6.36377H4ZM18 10.3638V8.36377H8V10.3638H18ZM12 6.36377H14V4.36377H18V2.36377H14V0.36377H12V6.36377Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M0 0.36377H18V18.3638H0V0.36377Z",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icons_tune = (tune);

// EXTERNAL MODULE: ./src/theme/text/index.js
var theme_text = __webpack_require__(5799);
// EXTERNAL MODULE: ./src/theme/tooltip/index.js
var tooltip = __webpack_require__(4509);
// EXTERNAL MODULE: ./src/theme/icons/reload.js
var reload = __webpack_require__(16490);
// EXTERNAL MODULE: ./src/theme/icons/options.js
var options = __webpack_require__(12012);
// EXTERNAL MODULE: ./node_modules/antd/es/switch/index.js + 1 modules
var es_switch = __webpack_require__(94594);
// EXTERNAL MODULE: ./src/translations/index.js + 4 modules
var translations = __webpack_require__(99408);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 178 modules
var motion = __webpack_require__(99009);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 7 modules
var input = __webpack_require__(68863);
// EXTERNAL MODULE: ./src/redux/action/wildcard.js
var wildcard = __webpack_require__(47011);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var reselect_es = __webpack_require__(68697);
;// CONCATENATED MODULE: ./src/redux/reselect/wildcard.js
/* eslint-disable camelcase */ 



var selectPayloadByKey = (0,reselect_es/* createSelector */.P1)(function(state) {
    return state.wildcard.payload;
}, function(_, key) {
    return key;
}, function(payload, key) {
    return payload[key];
});
/* harmony default export */ var reselect_wildcard = ((0,reselect_es/* createSelector */.P1)(selectPayloadByKey, config/* default */.ZP, function(payload) {
    if (!payload || !payload.data) return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
        payload: [],
        haveMore: false
    });
    var isWaiting = payload.isWaiting, _data = payload.data, _aggregations = _data.aggregations, _results = _aggregations.results, sum_other_doc_count = _results.sum_other_doc_count, buckets = _results.buckets;
    var result = buckets.map(function(bucket) {
        var key = JSON.stringify(bucket.key);
        return {
            key: key,
            label: bucket.key
        };
    }).sort(function(a, b) {
        var textA = a.label.toUpperCase();
        var textB = b.label.toUpperCase();
        // eslint-disable-next-line no-nested-ternary
        return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
    var haveMore = sum_other_doc_count > 0;
    return {
        isWaiting: isWaiting,
        payload: result,
        haveMore: haveMore
    };
}));

// EXTERNAL MODULE: ./src/theme/icons/check-circle.js
var check_circle = __webpack_require__(53107);
// EXTERNAL MODULE: ./src/theme/icons/alert.js
var icons_alert = __webpack_require__(88176);
;// CONCATENATED MODULE: ./src/theme/icons/search.js


function search() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "19",
        height: "19",
        viewBox: "0 0 19 19",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.55176 0.490234C10.1416 0.490234 13.0518 3.40038 13.0518 6.99023C13.0518 8.60023 12.4618 10.0802 11.4918 11.2202L11.7618 11.4902H12.5518L17.5518 16.4902L16.0518 17.9902L11.0518 12.9902V12.2002L10.7818 11.9302C9.64176 12.9002 8.16176 13.4902 6.55176 13.4902C2.96191 13.4902 0.0517578 10.5801 0.0517578 6.99023C0.0517578 3.40038 2.96191 0.490234 6.55176 0.490234ZM6.55176 2.49023C4.05176 2.49023 2.05176 4.49023 2.05176 6.99023C2.05176 9.49023 4.05176 11.4902 6.55176 11.4902C9.05176 11.4902 11.0518 9.49023 11.0518 6.99023C11.0518 4.49023 9.05176 2.49023 6.55176 2.49023Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0",
                "mask-type": "alpha",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "18",
                height: "18",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.55176 0.490234C10.1416 0.490234 13.0518 3.40038 13.0518 6.99023C13.0518 8.60023 12.4618 10.0802 11.4918 11.2202L11.7618 11.4902H12.5518L17.5518 16.4902L16.0518 17.9902L11.0518 12.9902V12.2002L10.7818 11.9302C9.64176 12.9002 8.16176 13.4902 6.55176 13.4902C2.96191 13.4902 0.0517578 10.5801 0.0517578 6.99023C0.0517578 3.40038 2.96191 0.490234 6.55176 0.490234ZM6.55176 2.49023C4.05176 2.49023 2.05176 4.49023 2.05176 6.99023C2.05176 9.49023 4.05176 11.4902 6.55176 11.4902C9.05176 11.4902 11.0518 9.49023 11.0518 6.99023C11.0518 4.49023 9.05176 2.49023 6.55176 2.49023Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0)"
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/theme/icons/loader.js
var loader = __webpack_require__(39024);
;// CONCATENATED MODULE: ./src/components/filters/more-filters/input/list.js
/* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: ",
        ";\n  position: absolute;\n  top: 30px;\n  left: 0;\n  right: 0;\n  padding-top: ",
        "px;\n  z-index: 999;\n\n  & > ul {\n    width: 100%;\n    max-height: 300px;\n    overflow: auto;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04),\n      0px 10px 20px rgba(0, 0, 0, 0.04);\n\n    border: 1px solid ",
        ";\n\n    & > li {\n      display: flex;\n      align-items: center;\n      padding: 0 ",
        "px;\n      min-width: 130px;\n      height: 48px;\n      border-bottom: 1px solid ",
        ";\n      background: ",
        ";\n\n      :last-child {\n        border-bottom: none;\n      }\n\n      :hover {\n        background: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  height: ",
        "px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  /* stylelint-disable */\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  /* stylelint-enable */\n  -webkit-line-clamp: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 ",
        "px;\n  min-width: 130px;\n  height: 48px;\n  border-bottom: 1px solid ",
        ";\n  background: ",
        ";\n  cursor: pointer;\n\n  :last-child {\n    border-bottom: none;\n  }\n\n  :hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: bold;\n  padding: 2px 6px;\n  border-radius: 3px;\n  cursor: pointer;\n  user-select: none;\n  \n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4ec320d8-0"
})(_templateObject(), dist_index_esm/* space */.Dh, function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "block" : "none";
}, (0,theme_get_dist_index_esm/* themeGet */.R)("space.xs"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_100"), (0,theme_get_dist_index_esm/* themeGet */.R)("space.xs"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_100"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.white"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_100"));
var TextEllipsis = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-4ec320d8-1"
})(_templateObject1(), dist_index_esm/* typography */.cp, dist_index_esm/* color */.$_, dist_index_esm/* space */.Dh, function(param) {
    var line = param.line;
    return line * 22;
}, function(param) {
    var line = param.line;
    return line;
});
var Item = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-4ec320d8-2"
})(_templateObject2(), (0,theme_get_dist_index_esm/* themeGet */.R)("space.xs"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_100"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.white"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_100"));
var ExcludeButton = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-4ec320d8-3"
})(_templateObject3(), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.red_400"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.red_100"));
function ItemComponent(param) {
    var option = param.option, onInclude = param.onInclude, onExclude = param.onExclude;
    var handleIncludeClick = (0,react.useCallback)(function() {
        onInclude(option.label);
    }, [
        onInclude,
        option
    ]);
    var handleExcludeClick = (0,react.useCallback)(function(e) {
        e.stopPropagation();
        onExclude(option.label);
    }, [
        onExclude,
        option
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
        onClick: handleIncludeClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextEllipsis, {
                fontSize: "display",
                lineHeight: "display",
                fontWeight: "medium",
                color: "grey_400",
                line: "2",
                children: option.label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExcludeButton, {
                onClick: handleExcludeClick,
                children: "-"
            })
        ]
    });
}
function List(param) {
    var haveMore = param.haveMore, options = param.options, isOpen = param.isOpen, onClick = param.onClick, onMore = param.onMore, onExclude = param.onExclude;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        isOpen: isOpen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            children: [
                options.map(function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemComponent, {
                        option: option,
                        onInclude: onClick,
                        onExclude: onExclude
                    }, option.key);
                }),
                haveMore && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    onClick: onMore,
                    children: "more..."
                })
            ]
        })
    });
}
/* harmony default export */ var list = (List);

;// CONCATENATED MODULE: ./src/components/filters/more-filters/input/index.js
/* eslint-disable no-nested-ternary */ 


function input_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    input_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function input_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  position: relative;\n\n  outline: 0;\n\n  .ant-input {\n    appearance: none;\n    margin: 0;\n    font-variant: tabular-nums;\n    list-style: none;\n    font-feature-settings: 'tnum';\n    position: relative;\n    display: inline-block;\n    color: ",
        ";\n    font-size: 16px;\n    line-height: 1.5715;\n    background-color: ",
        ";\n    background-image: none;\n    box-shadow: none;\n    transition: all 0.3s;\n    width: 100%;\n    height: 38px;\n    border: 2px solid;\n    border-color: ",
        ";\n    box-sizing: border-box;\n    border-radius: 4px;\n    padding: 0 ",
        "px;\n    padding-right: ",
        "px;\n\n    :hover {\n      border-color: ",
        ";\n    }\n\n    :focus {\n      border-color: ",
        ";\n    }\n\n    :disabled {\n      opacity: 0.5;\n    }\n\n    :placeholder-shown {\n      text-overflow: ellipsis;\n    }\n  }\n\n  .ant-input-affix-wrapper,\n  .ant-input-group {\n    position: relative;\n  }\n\n  .ant-input-suffix {\n    position: absolute;\n    right: ",
        "px;\n    top: 0px;\n    bottom: 0px;\n\n    .ant-input-password-icon {\n      color: ",
        ";\n\n      & > svg {\n        width: 18px;\n        height: 18px;\n      }\n    }\n  }\n\n  .ant-input-group-addon {\n    position: absolute;\n    right: ",
        "px;\n    top: 0px;\n    bottom: 0px;\n    color: ",
        ";\n  }\n"
    ]);
    input_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function input_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 10px;\n  height: 34px;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n"
    ]);
    input_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function input_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  width: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    input_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 18px;\n  height: 18px;\n  animation: ",
        " 2s linear infinite;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
















var rotate = (0,styled_components_browser_esm/* keyframes */.F4)(input_templateObject());
var input_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1bd4ac6f-0"
})(input_templateObject1(), dist_index_esm/* layout */.bK, dist_index_esm/* space */.Dh, dist_index_esm/* typography */.cp, (0,theme_get_dist_index_esm/* themeGet */.R)("colors.grey_400"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.white"), function(param) {
    var meta = param.meta;
    return meta.error && meta.touched ? (0,theme_get_dist_index_esm/* themeGet */.R)("colors.red_400") : (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_100");
}, (0,theme_get_dist_index_esm/* themeGet */.R)("space.s"), function(param) {
    var addonAfter = param.addonAfter;
    return addonAfter ? (0,theme_get_dist_index_esm/* themeGet */.R)("space.l") : (0,theme_get_dist_index_esm/* themeGet */.R)("space.s");
}, (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_200"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_500"), (0,theme_get_dist_index_esm/* themeGet */.R)("space.s"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.grey_600"), (0,theme_get_dist_index_esm/* themeGet */.R)("space.s"), function(param) {
    var meta = param.meta;
    return !meta.touched ? (0,theme_get_dist_index_esm/* themeGet */.R)("colors.grey_600") : meta.error ? (0,theme_get_dist_index_esm/* themeGet */.R)("colors.red_400") : (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_400");
});
var LabelColor = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1bd4ac6f-1"
})(input_templateObject2(), dist_index_esm/* color */.$_);
var WrapIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1bd4ac6f-2"
})(input_templateObject3(), dist_index_esm/* color */.$_);
var WrapLoader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1bd4ac6f-3"
})(_templateObject4(), rotate);
function CustomInput(param) {
    var addonAfter = param.addonAfter, disabled = param.disabled, meta = param.meta, placeholder = param.placeholder, style = param.style, data = param.data, onSelect = param.onSelect;
    var ref = (0,react.useRef)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react.useState)(""), value = ref1[0], setValue = ref1[1];
    var ref2 = (0,react.useState)(0), offset = ref2[0], setOffset = ref2[1];
    var ref3 = (0,react.useState)(false), isOpen = ref3[0], setIsOpen = ref3[1];
    var ref4 = (0,es/* useSelector */.v9)(reselect_filters/* default */.Z), dateTo = ref4.dateTo, dateFrom = ref4.dateFrom;
    var ref5 = (0,es/* useSelector */.v9)(function(state) {
        return reselect_wildcard(state, data.type);
    }), isWaiting = ref5.isWaiting, payload = ref5.payload;
    var paginatedResult = (0,react.useMemo)(function() {
        return payload.slice(0, 10 + offset);
    }, [
        offset,
        payload
    ]);
    var haveMore = (0,react.useMemo)(function() {
        var limit = 10 + offset;
        return payload.length > limit;
    }, [
        offset,
        payload
    ]);
    var getWildcards = (0,react.useCallback)(function(v) {
        dispatch((0,wildcard/* getWildcardRequest */.$U)({
            offset: 0,
            term: data.type,
            wildcard: v
        }));
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        dateFrom,
        dateTo
    ]);
    var handleChange = (0,react.useCallback)(function(e) {
        var _target = e.target, v = _target.value;
        setValue(v);
    }, []);
    var handleSubmit = (0,react.useCallback)(function(e) {
        e.preventDefault();
        var _target = e.target, v = _target.value;
        if (!v) return;
        onSelect({
            type: data.type,
            value: "".concat(data.type, "=").concat(v),
            label: v,
            color: data.color
        }, false);
        setIsOpen(false);
        setOffset(0);
        setValue("");
    }, [
        onSelect,
        data
    ]);
    var handleExclude = (0,react.useCallback)(function(label) {
        onSelect({
            type: data.type,
            value: "".concat(data.type, "=").concat(label),
            label: label,
            color: data.color
        }, true);
        setIsOpen(false);
        setOffset(0);
        setValue("");
    }, [
        onSelect,
        data
    ]);
    var handleMore = (0,react.useCallback)(function() {
        var newOffset = offset + 10;
        setOffset(newOffset);
        getWildcards(value, newOffset);
    }, [
        offset,
        value,
        getWildcards
    ]);
    (0,hooks/* useOutsideClick */.O3)(ref, function() {
        setIsOpen(false);
    });
    var addonAfterIcon = (0,react.useMemo)(function() {
        if (!addonAfter) return "";
        return meta.error && meta.touched ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_alert/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(check_circle/* default */.Z, {});
    }, [
        addonAfter,
        meta
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(input_Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        addonAfter: addonAfter,
        fontSize: "display",
        lineHeight: "display",
        fontWeight: "normal",
        meta: meta
    }, style), {
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                id: data.type,
                value: value,
                onPressEnter: handleSubmit,
                onChange: handleChange,
                placeholder: placeholder,
                disabled: disabled,
                addonAfter: addonAfterIcon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelColor, {
                bg: data.color || "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapIcon, {
                color: "primary_200",
                children: isWaiting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapLoader, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {
                        width: 18
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(search, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(list, {
                haveMore: haveMore,
                options: paginatedResult,
                isOpen: isOpen,
                onMore: handleMore,
                onExclude: handleExclude
            })
        ]
    }));
}
/* harmony default export */ var more_filters_input = (CustomInput);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 9 modules
var useInfiniteQuery = __webpack_require__(15285);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js + 45 modules
var es_select = __webpack_require__(40280);
// EXTERNAL MODULE: ./src/redux/reselect/auth.js
var auth = __webpack_require__(23741);
// EXTERNAL MODULE: ./src/api/index.js
var api = __webpack_require__(71312);
// EXTERNAL MODULE: ./src/theme/select/index.js
var theme_select = __webpack_require__(18198);
// EXTERNAL MODULE: ./src/theme/input-error/index.js
var input_error = __webpack_require__(26227);
;// CONCATENATED MODULE: ./src/components/filters/more-filters/select-remote/index.js
/* eslint-disable no-nested-ternary */ /* eslint-disable react/destructuring-assignment */ 



function select_remote_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  cursor: pointer;\n  \n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    select_remote_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function select_remote_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: bold;\n  font-size: 9px;\n  text-transform: uppercase;\n  padding: 2px 6px;\n  border-radius: 3px;\n  cursor: pointer;\n  user-select: none;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  line-height: 1;\n  \n  &:hover {\n    background-color: ",
        ";\n    border-color: ",
        ";\n  }\n"
    ]);
    select_remote_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function select_remote_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  height: 100%;\n\n  & > .cover {\n    width: 48px;\n  }\n\n  & > .right {\n    width: 180px;\n    margin-left: 8px;\n  }\n\n  & > .without-cover {\n    width: 100%;\n  }\n"
    ]);
    select_remote_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function select_remote_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  text-overflow:ellipsis;\n  overflow: hidden;\n  display: -webkit-box !important;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  white-space: normal;\n"
    ]);
    select_remote_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}















var Option = es_select/* default.Option */.Z.Option;
var OptionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64fa439-0"
})(select_remote_templateObject(), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_50"));
var select_remote_ExcludeButton = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-64fa439-1"
})(select_remote_templateObject1(), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.red_400"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.red_50"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.red_200"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.red_100"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.red_300"));
var TitleCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-64fa439-2"
})(select_remote_templateObject2());
var select_remote_TextEllipsis = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-64fa439-3"
})(select_remote_templateObject3(), dist_index_esm/* typography */.cp, dist_index_esm/* color */.$_, dist_index_esm/* space */.Dh);
function SelectRemote(param) {
    var className = param.className, defaultValue = param.defaultValue, disabled = param.disabled, input = param.input, meta = param.meta, style = param.style, noError = param.noError, languageCode = param.languageCode, data = param.data, dataType = param.dataType;
    var ref = (0,es/* useSelector */.v9)(auth/* default */.Z), accessToken = ref.signInUserSession.accessToken, adminRequestedStreetlibInternalId = ref.adminRequestedStreetlibInternalId;
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var ref2 = (0,react.useState)(""), searchQuery = ref2[0], setSearchQuery = ref2[1];
    var ref3 = (0,react.useState)(""), searchInput = ref3[0], setSearchInput = ref3[1];
    var query = (0,useInfiniteQuery/* useInfiniteQuery */.N)([
        "filter",
        data.type,
        searchQuery
    ], function(param) {
        var _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 1 : _pageParam;
        var _obj;
        var params = (_obj = {}, (0,_define_property/* default */.Z)(_obj, data.params, searchQuery), (0,_define_property/* default */.Z)(_obj, "page", pageParam), (0,_define_property/* default */.Z)(_obj, "locale", data.locale ? languageCode : undefined), _obj);
        if (dataType === "usage_data") params["q[anay_filter_usage_eq]"] = true;
        else if (dataType === "sales_data") params["q[anay_filter_sales_eq]"] = true;
        else params["q[anay_filter_earns_eq]"] = true;
        return (0,api/* getAnalyticsFilters */.fJ)(languageCode, accessToken, adminRequestedStreetlibInternalId, data.endpoint, params);
    }, {
        enabled: isOpen,
        getNextPageParam: function(lastPage, allPages) {
            return lastPage.headers["per-page"] * allPages.length <= lastPage.headers.total ? allPages.length + 1 : undefined;
        }
    });
    var handleChange = (0,react.useCallback)(function(value, option) {
        if (value === "") {
            return null;
        }
        if (value === "moreKey") {
            return query.fetchNextPage();
        }
        setIsOpen(false);
        setSearchInput("");
        setSearchQuery("");
        var label = "";
        if (data.type === "title_search" || data.type === "main_category_search") {
            var ref, ref1, ref2;
            // For title_search, we need to find the original option to get the ISBN
            // For main_category_search, we need the name_localized
            var originalOption = (ref2 = (ref = query.data) === null || ref === void 0 ? void 0 : (ref1 = ref.pages) === null || ref1 === void 0 ? void 0 : ref1.flatMap(function(page) {
                return page.data;
            })) === null || ref2 === void 0 ? void 0 : ref2.find(function(opt) {
                var optValue = "".concat(data.valueKey, "=").concat(opt[data.value]);
                return optValue === value;
            });
            if (originalOption) {
                if (data.type === "title_search") {
                    // Use ISBN for title_search instead of title
                    label = originalOption.isbn || originalOption.title || value.split("=")[1] || value;
                } else {
                    // For main_category_search, use name_localized
                    label = originalOption.name_localized || originalOption.name || value.split("=")[1] || value;
                }
            } else {
                // Fallback: try to extract from option structure
                try {
                    var _children = option.children, children = _children.props.children;
                    var child = data.type === "main_category_search" ? children : children[1];
                    var _props = child.props, rightChildren = _props.children;
                    if (data.type === "title_search") {
                        var ref3, ref4, ref5, ref6;
                        // Try to get ISBN (second child) instead of title (first child)
                        var isbn = ((ref3 = rightChildren[1]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.props) === null || ref4 === void 0 ? void 0 : ref4.children) || ((ref5 = rightChildren[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.props) === null || ref6 === void 0 ? void 0 : ref6.children);
                        label = isbn;
                    } else {
                        var title = rightChildren[0].props.children;
                        label = title;
                    }
                } catch (error) {
                    // Fallback: use the value if we can't extract the label
                    label = value.split("=")[1] || value;
                }
            }
        } else if (option.children && typeof option.children === "object") {
            // Real data is in option.children, need to extract it
            // Try to extract data from children props
            if (option.children.props && option.children.props.children) {
                // If children is an array, take the first element (the name text)
                // The second element is the NOT button
                if (Array.isArray(option.children.props.children)) {
                    var firstChild = option.children.props.children[0];
                    // If the first child is a React object, extract text from its props
                    if (firstChild && typeof firstChild === "object" && firstChild.props) {
                        if (firstChild.props.children) {
                            label = String(firstChild.props.children);
                        } else {
                            label = String(firstChild);
                        }
                    } else {
                        label = String(firstChild);
                    }
                } else {
                    label = String(option.children.props.children);
                }
            } else {
                var ref7, ref8, ref9;
                // If nothing found in props, try to find the original option data
                // Need to find the original option data that was used to create the Option
                // Try to extract from value which should contain the data
                // The value is "store_id=44", need to find the original option
                // Search in the options array to find the one with the same value
                var originalOption1 = (ref9 = (ref7 = query.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.pages) === null || ref8 === void 0 ? void 0 : ref8.flatMap(function(page) {
                    return page.data;
                })) === null || ref9 === void 0 ? void 0 : ref9.find(function(opt) {
                    var optValue = "".concat(data.valueKey, "=").concat(opt[data.value]);
                    return optValue === value;
                });
                if (originalOption1) {
                    if (data.labelKey === "name_localized" && !originalOption1[data.labelKey]) {
                        label = originalOption1.name;
                    } else if (data.labelKey2 && originalOption1[data.labelKey2]) {
                        label = "".concat(originalOption1[data.labelKey], " (").concat(originalOption1[data.labelKey2], ")");
                    } else {
                        label = originalOption1[data.labelKey];
                    }
                } else {
                    // Fallback: use the value
                    label = value.split("=")[1] || value;
                }
            }
        } else if (option[data.labelKey]) {
            // If nothing found, try with option directly
            if (data.labelKey === "name_localized" && !option[data.labelKey]) {
                label = option.name;
            } else if (data.labelKey2 && option[data.labelKey2]) {
                label = "".concat(option[data.labelKey], " (").concat(option[data.labelKey2], ")");
            } else {
                label = option[data.labelKey];
            }
        } else if (option.props && option.props.children) {
            // If still nothing found, try with option data
            // Try to extract from option props
            label = String(option.props.children);
        } else {
            // Fallback: use the value
            label = value.split("=")[1] || value;
        }
        // Ensure label is a primitive string and not empty
        var cleanLabel = String(label || "");
        if (!cleanLabel || cleanLabel === "undefined" || cleanLabel === "null") {
            cleanLabel = value.split("=")[1] || value;
        }
        return input.onChange({
            type: data.type,
            value: value,
            label: cleanLabel,
            color: data.color
        }, false);
    }, [
        input,
        query,
        data
    ]);
    var handleExcludeClick = (0,react.useCallback)(function(e, optionValue, optionLabel) {
        e.stopPropagation();
        setIsOpen(false);
        setSearchInput("");
        setSearchQuery("");
        // Ensure optionLabel is a primitive string
        var cleanLabel = "";
        if (typeof optionLabel === "string" && optionLabel.trim()) {
            cleanLabel = optionLabel;
        } else if (typeof optionLabel === "object" && optionLabel !== null) {
            // If it's a React object, try to extract the text
            try {
                if (optionLabel.props && optionLabel.props.children) {
                    cleanLabel = String(optionLabel.props.children);
                } else {
                    cleanLabel = String(optionLabel);
                }
            } catch (error) {
                // Fallback: use the value if we can't extract the label
                cleanLabel = optionValue.split("=")[1] || optionValue;
            }
        } else {
            cleanLabel = String(optionLabel || "");
        }
        // Ensure cleanLabel is not empty
        if (!cleanLabel || cleanLabel === "undefined" || cleanLabel === "null") {
            cleanLabel = optionValue.split("=")[1] || optionValue;
        }
        return input.onChange({
            type: data.type,
            value: optionValue,
            label: cleanLabel,
            color: data.color
        }, true); // Always exclusive when clicking the button
    }, [
        input,
        data
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var delayedHandleChange = (0,react.useCallback)((0,lodash.debounce)(function(value) {
        setSearchQuery(value);
    }, 1000), []);
    var handleSearch = (0,react.useCallback)(function(e) {
        if (e.length > 0) {
            setIsOpen(true);
        }
        setSearchInput(e);
        delayedHandleChange(e);
    }, [
        delayedHandleChange
    ]);
    var handleClose = (0,react.useCallback)(function() {
        setIsOpen(false);
        setSearchQuery("");
    }, []);
    var handleOpen = (0,react.useCallback)(function() {
        setIsOpen(true);
        setSearchQuery("");
    }, []);
    var selectOpen = (0,react.useMemo)(function() {
        return isOpen && (!query.isLoading || searchInput.length > 0);
    }, [
        searchInput,
        isOpen,
        query
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(theme_select/* StyledSelect */.Q, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className,
        fontSize: "display",
        lineHeight: "display",
        fontWeight: "normal",
        error: meta.error && meta.touched,
        disabled: disabled
    }, style), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_select/* default */.Z, {
                value: "",
                onChange: handleChange,
                defaultValue: defaultValue,
                loading: query.isLoading && isOpen,
                open: selectOpen,
                onFocus: handleOpen,
                onBlur: handleClose,
                showSearch: data.showSearch,
                searchValue: searchInput,
                onSearch: data.showSearch ? handleSearch : null,
                filterOption: false,
                children: [
                    !!query.data && query.data.pages.map(function(page, pageIndex) {
                        // Create unique key using filter type and search query to avoid index-based keys
                        var uniqueKey = "".concat(data.type, "-").concat(searchQuery || "default", "-").concat(pageIndex, "-").concat(page.data.length);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: page.data.map(function(option) {
                                return data.type === "title_search" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                                    value: "".concat(data.valueKey, "=").concat(option[data.value]),
                                    className: "ant-select-title-option",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OptionWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleCard, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "cover",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            width: "100%",
                                                            height: "100%",
                                                            src: option.cover ? option.cover.url : "/images/book-placeholder.jpg",
                                                            alt: ""
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "right",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(select_remote_TextEllipsis, {
                                                                fontSize: "pSmall",
                                                                lineHeight: "pSmall",
                                                                fontWeight: "bold",
                                                                children: option.title
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                                                fontSize: "pSmall",
                                                                lineHeight: "pSmall",
                                                                fontWeight: "medium",
                                                                children: option.isbn
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                                                fontSize: "pSmall",
                                                                lineHeight: "pSmall",
                                                                fontWeight: "medium",
                                                                children: option.authors ? option.authors[0].composite_name : ""
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(select_remote_ExcludeButton, {
                                                onClick: function(e) {
                                                    return handleExcludeClick(e, "".concat(data.valueKey, "=").concat(option[data.value]), option.isbn || option.title);
                                                },
                                                children: "NOT"
                                            })
                                        ]
                                    })
                                }, "".concat(data.valueKey, "=").concat(option[data.value])) : data.type === "main_category_search" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                                    value: "".concat(data.valueKey, "=").concat(option[data.value]),
                                    className: "ant-select-main_category-option",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OptionWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleCard, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "without-cover",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(select_remote_TextEllipsis, {
                                                            fontSize: "pSmall",
                                                            lineHeight: "pSmall",
                                                            fontWeight: "bold",
                                                            children: option.name_localized
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                                            fontSize: "pSmall",
                                                            lineHeight: "pSmall",
                                                            fontWeight: "medium",
                                                            children: option.code
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(select_remote_ExcludeButton, {
                                                onClick: function(e) {
                                                    return handleExcludeClick(e, "".concat(data.valueKey, "=").concat(option[data.value]), option.name_localized);
                                                },
                                                children: "NOT"
                                            })
                                        ]
                                    })
                                }, "".concat(data.valueKey, "=").concat(option[data.value])) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                                    value: "".concat(data.valueKey.replace("[lang]", languageCode), "=").concat(option[data.value]),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OptionWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: data.labelKey === "name_localized" && !option[data.labelKey] ? option.name : data.labelKey2 && option[data.labelKey2] ? "".concat(option[data.labelKey], " (").concat(option[data.labelKey2], ")") : option[data.labelKey]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(select_remote_ExcludeButton, {
                                                onClick: function(e) {
                                                    return handleExcludeClick(e, "".concat(data.valueKey.replace("[lang]", languageCode), "=").concat(option[data.value]), data.labelKey === "name_localized" && !option[data.labelKey] ? option.name : data.labelKey2 && option[data.labelKey2] ? "".concat(option[data.labelKey], " (").concat(option[data.labelKey2], ")") : option[data.labelKey]);
                                                },
                                                children: "NOT"
                                            })
                                        ]
                                    })
                                }, "".concat(data.valueKey.replace("[lang]", languageCode), "=").concat(option[data.value]));
                            })
                        }, uniqueKey);
                    }),
                    query.hasNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                        value: "moreKey",
                        children: translations/* default */.Z[languageCode]["More..."]
                    }),
                    query.isLoading && (!query.data || query.data.pages.length === 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                        value: ""
                    })
                ]
            }),
            !noError && /*#__PURE__*/ (0,jsx_runtime.jsx)(input_error/* default */.Z, {
                value: input.value,
                meta: meta,
                languageCode: languageCode || "en"
            })
        ]
    }));
}
/* harmony default export */ var select_remote = (SelectRemote);

;// CONCATENATED MODULE: ./src/components/filters/more-filters/index.js

function more_filters_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > .ant-select > .ant-select-selector {\n    height: 38px;\n    border-color: ",
        ";\n\n    :hover {\n      border-color: ",
        ";\n    }\n\n    :focus {\n      border-color: ",
        ";\n    }\n  }\n\n  & > .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\n    height: 38px;\n  }\n"
    ]);
    more_filters_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function more_filters_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    more_filters_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function more_filters_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 10px;\n  height: 34px;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n"
    ]);
    more_filters_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function more_filters_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: ",
        ";\n\n  .container {\n    ",
        "\n    ",
        "\n\n    border: 2px solid ",
        ";\n    border-radius: 12px;\n\n    & > .filter-head {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      padding: ",
        "px;\n      padding-bottom: 0;\n\n      & > .left {\n        display: flex;\n        flex-direction: row;\n      }\n\n      & > .right {\n        .link {\n          display: flex;\n          align-items: center;\n          text-decoration: none;\n          cursor: pointer;\n          color: ",
        ";\n\n          & > :hover {\n            color: ",
        ";\n          }\n        }\n      }\n    }\n\n    & > .filter-body {\n      display: flex;\n      flex-direction: row;\n      padding: ",
        "px;\n      flex-wrap: wrap;\n\n      & > .wrap-input {\n        width: 279px;\n        padding: ",
        "px;\n      }\n    }\n  }\n"
    ]);
    more_filters_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












var StyledSelect = (0,styled_components_browser_esm/* default */.ZP)(select_remote).withConfig({
    componentId: "sc-68f7d98d-0"
})(more_filters_templateObject(), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_100"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_200"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_500"));
var WrapSelect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-68f7d98d-1"
})(more_filters_templateObject1());
var more_filters_LabelColor = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-68f7d98d-2"
})(more_filters_templateObject2(), dist_index_esm/* color */.$_);
var more_filters_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(motion/* motion.div */.E.div).withConfig({
    componentId: "sc-68f7d98d-3"
})(more_filters_templateObject3(), function(param) {
    var opened = param.opened;
    return opened === "true" ? "visible" : "hidden";
}, dist_index_esm/* color */.$_, dist_index_esm/* space */.Dh, (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_200"), (0,theme_get_dist_index_esm/* themeGet */.R)("space.m"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_400"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_300"), (0,theme_get_dist_index_esm/* themeGet */.R)("space.m"), (0,theme_get_dist_index_esm/* themeGet */.R)("space.xs"));
function MoreFilters(param) {
    var onReset = param.onReset, isOpen = param.isOpen, languageCode = param.languageCode, otherFilter = param.otherFilter, onChangeOtherFilter = param.onChangeOtherFilter, onChangeTermFilter = param.onChangeTermFilter, dataType = param.dataType;
    var variants = (0,react.useRef)({
        visible: {
            opacity: 1,
            height: "auto"
        },
        hidden: {
            opacity: 0,
            height: "0px"
        }
    });
    var handleChangeSelect = (0,react.useCallback)(function(selected) {
        var isExclusive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (selected.value !== "") {
            if (selected.type === "order_type") {
                return onChangeTermFilter(selected.type, selected.label, selected.value, selected.color, isExclusive);
            }
            return onChangeOtherFilter(selected.type, selected.label, selected.value, selected.color, isExclusive);
        }
        return null;
    }, [
        onChangeTermFilter,
        onChangeOtherFilter
    ]);
    var handleInputSelect = (0,react.useCallback)(function(selected) {
        var isExclusive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (selected.value !== "") {
            if (selected.type === "order_type") {
                return onChangeTermFilter(selected.type, selected.label, selected.value, selected.color, isExclusive);
            }
            return onChangeOtherFilter(selected.type, selected.label, selected.value, selected.color, isExclusive);
        }
        return null;
    }, [
        onChangeTermFilter,
        onChangeOtherFilter
    ]);
    var isAdminAnalytics = (0,es/* useSelector */.v9)(profile/* default */.Z).isAdminAnalytics;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(more_filters_Wrapper, {
        mt: "m",
        bg: "white",
        initial: "hidden",
        opened: isOpen.toString(),
        animate: isOpen ? "visible" : "hidden",
        variants: variants.current,
        transition: {
            ease: "linear",
            duration: 0.6
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "filter-head",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: "h2",
                                lineHeight: "h2",
                                fontWeight: "bold",
                                color: "grey_600",
                                children: translations/* default */.Z[languageCode].filters
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "right",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                title: translations/* default */.Z[languageCode].reset,
                                type: "button",
                                className: "link",
                                onClick: onReset,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                    fontSize: "pLarge",
                                    lineHeight: "pLarge",
                                    fontWeight: "bold",
                                    color: "grey_600",
                                    children: translations/* default */.Z[languageCode].reset
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "filter-body",
                    children: otherFilter.map(function(filter) {
                        return (!filter.isAdmin || isAdminAnalytics && filter.isAdmin) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "wrap-input",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                    fontSize: "display",
                                    lineHeight: "display",
                                    fontWeight: "bold",
                                    color: "grey_600",
                                    children: filter.label
                                }),
                                !filter.endpoint ? /*#__PURE__*/ (0,jsx_runtime.jsx)(more_filters_input, {
                                    data: filter,
                                    meta: {},
                                    onSelect: handleInputSelect
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapSelect, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelect, {
                                            input: {
                                                value: "",
                                                onChange: handleChangeSelect
                                            },
                                            data: filter,
                                            languageCode: languageCode,
                                            meta: {},
                                            noError: true,
                                            dataType: dataType
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(more_filters_LabelColor, {
                                            bg: filter.color || "black"
                                        })
                                    ]
                                })
                            ]
                        }, filter.type);
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var more_filters = (MoreFilters);

// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/index.js + 19 modules
var config_provider = __webpack_require__(26766);
// EXTERNAL MODULE: ./src/theme/buttons/btn.js
var btn = __webpack_require__(84146);
// EXTERNAL MODULE: ./node_modules/react-date-range/dist/index.js
var dist = __webpack_require__(30286);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/it/index.js + 6 modules
var it = __webpack_require__(58160);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/de/index.js + 5 modules
var de = __webpack_require__(70879);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/pt/index.js + 5 modules
var pt = __webpack_require__(94952);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js + 5 modules
var en_US = __webpack_require__(95826);
// EXTERNAL MODULE: ./node_modules/react-date-range/dist/styles.css
var styles = __webpack_require__(71541);
// EXTERNAL MODULE: ./node_modules/react-date-range/dist/theme/default.css
var theme_default = __webpack_require__(32049);
;// CONCATENATED MODULE: ./src/theme/range-picker/index.js

function range_picker_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  .rdrDateDisplayWrapper {\n    background-color: transparent;\n  }\n\n  .rdrDateDisplay {\n    margin: 0;\n  }\n\n  .rdrDateInput {\n    height: 44px;\n  }\n\n  .rdrDateDisplayItem {\n    box-shadow: none;\n    border: 2px solid ",
        ";\n\n    & > input {\n      font-size: 16px;\n      height: 100%;\n    }\n  }\n\n  .rdrDateDisplayItemActive {\n    box-shadow: none;\n    border: 2px solid ",
        ";\n  }\n\n  .rdrDayToday .rdrDayNumber span:after {\n    background: ",
        ";\n  }\n\n  .rdrMonthAndYearPickers select:hover {\n    background-color: transparent;\n  }\n"
    ]);
    range_picker_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var StyledDateRange = (0,styled_components_browser_esm/* default */.ZP)(dist/* DateRange */.C0).withConfig({
    componentId: "sc-9928b222-0"
})(range_picker_templateObject(), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_200"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_300"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_300"));
function CustomDateRange(param) {
    var maxRange = param.maxRange, minDate = param.minDate, languageCode = param.languageCode, onChange = param.onChange, value = param.value;
    var dates = (0,react.useMemo)(function() {
        return {
            startDate: moment_default()(value[0]).toDate(),
            endDate: moment_default()(value[1]).toDate(),
            key: "selection"
        };
    }, [
        value
    ]);
    var handleChange = (0,react.useCallback)(function(item) {
        var _selection = item.selection, startDate = _selection.startDate, endDate = _selection.endDate;
        var endDateFormatted = moment_default()(endDate);
        if (maxRange && moment_default()(startDate).add(maxRange, "months").isBefore(endDateFormatted)) {
            endDateFormatted = moment_default()(startDate);
        }
        if (moment_default()(endDate).isAfter(moment_default()())) {
            endDateFormatted = moment_default()();
        }
        onChange([
            moment_default()(startDate),
            endDateFormatted
        ]);
    }, [
        onChange,
        maxRange
    ]);
    var maxDate = (0,react.useMemo)(function() {
        if (maxRange) {
            return moment_default()(value[0]).add(maxRange, "months").toDate();
        }
        return moment_default()().toDate();
    }, [
        maxRange,
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDateRange, {
        editableDateInputs: true,
        months: 2,
        direction: "horizontal",
        onChange: handleChange,
        moveRangeOnFirstSelection: false,
        minDate: minDate,
        maxDate: maxDate,
        ranges: [
            dates
        ],
        rangeColors: [
            "#0A8EA0"
        ],
        dateDisplayFormat: "dd MMM yyyy",
        locale: languageCode === "it" ? it/* default */.Z : languageCode === "de" ? de/* default */.Z : languageCode === "pt" ? pt/* default */.Z : en_US["default"]
    });
}
/* harmony default export */ var range_picker = (CustomDateRange);

// EXTERNAL MODULE: ./node_modules/antd/lib/locale/it_IT.js
var it_IT = __webpack_require__(29168);
// EXTERNAL MODULE: ./node_modules/antd/lib/locale/en_US.js
var locale_en_US = __webpack_require__(18253);
// EXTERNAL MODULE: ./node_modules/antd/lib/locale/de_DE.js
var de_DE = __webpack_require__(17699);
;// CONCATENATED MODULE: ./src/components/filters/date-selector/index.js



function date_selector_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  flex: 1;\n\n  & > .button-wrapper {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    flex: 1;\n\n    & > .column {\n      display: flex;\n      flex-direction: column;\n      margin-right: ",
        "px;\n\n      & > .flex {\n        display: flex;\n        align-items: center;\n      }\n    }\n  }\n"
    ]);
    date_selector_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function date_selector_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  display: ",
        ";\n\n  width: 596px;\n  position: absolute;\n  top: 52px;\n  border: 2px solid;\n  border-radius: 12px;\n  z-index: 999;\n\n  ",
        ";\n\n  ",
        "\n\n  & > .row {\n    display: flex;\n    flex-direction: row;\n\n    & > div {\n      flex: 1;\n    }\n\n    & > :first-child {\n      margin-right: ",
        "px;\n    }\n  }\n\n  & > .buttons {\n    padding-top: ",
        "px;\n    justify-content: space-between;\n  }\n"
    ]);
    date_selector_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


















var date_selector_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e859ca89-0"
})(date_selector_templateObject(), (0,theme_get_dist_index_esm/* themeGet */.R)("space.s"));
var Menu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e859ca89-1"
})(date_selector_templateObject1(), dist_index_esm/* space */.Dh, dist_index_esm/* color */.$_, function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "block" : "none";
}, function(param) {
    var direction = param.direction;
    return direction === "right" ? "right: 0" : "left: 0";
}, dist_index_esm/* border */.Cg, (0,theme_get_dist_index_esm/* themeGet */.R)("space.s"), (0,theme_get_dist_index_esm/* themeGet */.R)("space.l"));
function DateSelector(param) {
    var direction = param.direction, compare = param.compare, dataType = param.dataType, dateRange = param.dateRange, selectByFilter = param.selectByFilter, dates = param.dates;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useRef)();
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setOpen = ref1[1];
    var ref2 = (0,react.useState)({
        compare: compare,
        dataType: dataType,
        dateRange: dateRange,
        dates: dates
    }), filtersState = ref2[0], setFiltersState = ref2[1];
    (0,react.useEffect)(function() {
        setFiltersState({
            compare: compare,
            dataType: dataType,
            dateRange: dateRange,
            dates: dates
        });
    }, [
        compare,
        dataType,
        dateRange,
        dates
    ]);
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var dateRangeValue = (0,react.useMemo)(function() {
        var result = selectByFilter.find(function(el) {
            return el.value === dateRange;
        });
        if (result && result.label) {
            return result.label;
        }
        return "Custom";
    }, [
        dateRange,
        selectByFilter
    ]);
    var handleOpen = (0,react.useCallback)(function() {
        setOpen(!isOpen);
    }, [
        isOpen
    ]);
    var handleCancel = (0,react.useCallback)(function() {
        setFiltersState({
            compare: compare,
            dataType: dataType,
            dateRange: dateRange,
            dates: dates
        });
        setOpen(false);
    }, [
        compare,
        dataType,
        dateRange,
        dates
    ]);
    var handleApply = (0,react.useCallback)(function() {
        setOpen(false);
        dispatch((0,action_filters/* changeFilters */.P7)(filtersState));
    }, [
        filtersState,
        dispatch
    ]);
    var handleChangeCompare = (0,react.useCallback)(function(payload) {
        setFiltersState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filtersState), {
            compare: payload
        }));
    }, [
        filtersState
    ]);
    var handleChangeDateRange = (0,react.useCallback)(function(payload) {
        var calculatedDates = (0,calculate_range/* default */.Z)(payload);
        setFiltersState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filtersState), {
            dateRange: payload,
            dates: calculatedDates
        }));
    }, [
        filtersState
    ]);
    var handleChangeDates = (0,react.useCallback)(function(payload) {
        if (!payload) {
            var defaultRange = selectByFilter[0].value;
            var defaultDates = (0,calculate_range/* default */.Z)(defaultRange);
            setFiltersState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filtersState), {
                dates: defaultDates
            }));
        } else {
            setFiltersState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filtersState), {
                dateRange: "custom",
                dates: payload
            }));
        }
    }, [
        filtersState,
        selectByFilter
    ]);
    var getLocale = (0,react.useCallback)(function() {
        switch(languageCode){
            case "it":
                return it_IT/* default */.Z;
            case "de":
                return de_DE/* default */.Z;
            default:
                return locale_en_US/* default */.Z;
        }
    }, [
        languageCode
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(config_provider/* default */.ZP, {
        locale: getLocale(),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(date_selector_Wrapper, {
            ref: ref,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "button-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(btn_border/* default */.Z, {
                        onClick: handleOpen,
                        style: {
                            width: "100%",
                            maxWidth: "190px",
                            height: "48px",
                            p: 0,
                            mr: "s",
                            color: "grey_400"
                        },
                        type: "button",
                        label: dateRangeValue
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu, {
                    direction: direction,
                    bg: "white",
                    isVisible: isOpen,
                    px: "s",
                    py: "m",
                    borderColor: "primary_200",
                    mt: "10px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                            fontSize: "label",
                            lineHeight: "label",
                            fontWeight: "bold",
                            color: "grey_600",
                            mb: "s",
                            children: translations/* default */.Z[languageCode]["date range"]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_select/* default */.Z, {
                            meta: {},
                            input: {
                                value: filtersState.dateRange,
                                onChange: handleChangeDateRange
                            },
                            defaultValue: selectByFilter[0].value,
                            options: selectByFilter,
                            noError: true,
                            style: {
                                mb: "s"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                            fontSize: "label",
                            lineHeight: "label",
                            fontWeight: "bold",
                            color: "grey_600",
                            mb: "s",
                            children: translations/* default */.Z[languageCode]["specific date"]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(range_picker, {
                            languageCode: languageCode,
                            value: filtersState.dates,
                            onChange: handleChangeDates
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                        fontSize: "label",
                                        lineHeight: "label",
                                        fontWeight: "bold",
                                        color: "grey_600",
                                        mb: "s",
                                        children: translations/* default */.Z[languageCode]["compare to"]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_select/* default */.Z, {
                                        meta: {},
                                        input: {
                                            value: filtersState.compare,
                                            onChange: handleChangeCompare
                                        },
                                        options: [
                                            {
                                                label: translations/* default */.Z[languageCode].period,
                                                value: "period"
                                            },
                                            {
                                                label: translations/* default */.Z[languageCode].year,
                                                value: "year"
                                            }, 
                                        ],
                                        noError: true
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row buttons",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(btn_border/* default */.Z, {
                                    onClick: handleCancel,
                                    style: {
                                        width: "100%",
                                        maxWidth: "110px",
                                        minWidth: "110px",
                                        height: "48px",
                                        p: 0,
                                        color: "grey_400"
                                    },
                                    type: "button",
                                    label: translations/* default */.Z[languageCode].cancel
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(btn/* default */.Z, {
                                    onClick: handleApply,
                                    style: {
                                        width: "100%",
                                        maxWidth: "110px",
                                        minWidth: "110px",
                                        height: "48px",
                                        p: 0
                                    },
                                    type: "button",
                                    label: translations/* default */.Z[languageCode].apply
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var date_selector = (DateSelector);

// EXTERNAL MODULE: ./src/redux/action/preset.js
var preset = __webpack_require__(97169);
;// CONCATENATED MODULE: ./src/redux/reselect/preset.js
/* eslint-disable camelcase */ 
/* harmony default export */ var reselect_preset = ((0,reselect_es/* createSelector */.P1)(function(state) {
    return state.preset.payload;
}, function(payload) {
    var settings = payload.settings;
    if (!settings) return {};
    var presetSetting = settings.find(function(setting) {
        return setting.code === "PRESETS";
    });
    if (!presetSetting) return {};
    var settingId = presetSetting.id, user_settings = presetSetting.user_settings;
    if (!user_settings) {
        return {
            settingId: settingId,
            id: null,
            presets: null
        };
    }
    var id = user_settings.id, data = user_settings.data;
    if (!data) {
        return {
            settingId: settingId,
            id: id,
            presets: null
        };
    }
    var presets = data.presets;
    return {
        settingId: settingId,
        id: id,
        presets: presets
    };
}));

// EXTERNAL MODULE: ./src/theme/modal/index.js
var modal = __webpack_require__(75436);
;// CONCATENATED MODULE: ./src/components/filters/manage-preset/search/index.js
/* eslint-disable no-nested-ternary */ 


function search_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  position: relative;\n\n  outline: 0;\n\n  .ant-input {\n    appearance: none;\n    margin: 0;\n    font-variant: tabular-nums;\n    list-style: none;\n    font-feature-settings: 'tnum';\n    position: relative;\n    display: inline-block;\n    color: ",
        ";\n    font-size: 16px;\n    line-height: 1.5715;\n    background-color: ",
        ";\n    background-image: none;\n    box-shadow: none;\n    transition: all 0.3s;\n    width: 100%;\n    height: 38px;\n    border: 2px solid;\n    border-color: ",
        ";\n    box-sizing: border-box;\n    border-radius: 4px;\n    padding: 0 ",
        "px;\n    padding-right: ",
        "px;\n\n    :hover {\n      border-color: ",
        ";\n    }\n\n    :focus {\n      border-color: ",
        ";\n    }\n\n    :disabled {\n      opacity: 0.5;\n    }\n\n    :placeholder-shown {\n      text-overflow: ellipsis;\n    }\n  }\n\n  .ant-input-affix-wrapper,\n  .ant-input-group {\n    position: relative;\n  }\n\n  .ant-input-suffix {\n    position: absolute;\n    right: ",
        "px;\n    top: 0px;\n    bottom: 0px;\n\n    .ant-input-password-icon {\n      color: ",
        ";\n\n      & > svg {\n        width: 18px;\n        height: 18px;\n      }\n    }\n  }\n\n  .ant-input-group-addon {\n    position: absolute;\n    right: ",
        "px;\n    top: 0px;\n    bottom: 0px;\n  }\n"
    ]);
    search_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function search_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  width: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    search_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var search_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-422593e-0"
})(search_templateObject(), dist_index_esm/* layout */.bK, dist_index_esm/* space */.Dh, dist_index_esm/* typography */.cp, (0,theme_get_dist_index_esm/* themeGet */.R)("colors.grey_400"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.white"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_100"), (0,theme_get_dist_index_esm/* themeGet */.R)("space.s"), function(param) {
    var addonAfter = param.addonAfter;
    return addonAfter ? (0,theme_get_dist_index_esm/* themeGet */.R)("space.l") : (0,theme_get_dist_index_esm/* themeGet */.R)("space.s");
}, (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_200"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_500"), (0,theme_get_dist_index_esm/* themeGet */.R)("space.s"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.grey_600"), (0,theme_get_dist_index_esm/* themeGet */.R)("space.s"));
var search_WrapIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-422593e-1"
})(search_templateObject1(), dist_index_esm/* color */.$_);
function SearchInput(param) {
    var addonAfter = param.addonAfter, autoComplete = param.autoComplete, disabled = param.disabled, placeholder = param.placeholder, style = param.style, value = param.value, onChange = param.onChange;
    var handleChange = (0,react.useCallback)(function(e) {
        var _target = e.target, v = _target.value;
        onChange(v);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(search_Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        addonAfter: addonAfter,
        fontSize: "display",
        lineHeight: "display",
        fontWeight: "normal"
    }, style), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                value: value,
                onChange: handleChange,
                autoComplete: autoComplete,
                placeholder: placeholder,
                disabled: disabled
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(search_WrapIcon, {
                color: "primary_200",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(search, {})
            })
        ]
    }));
}
/* harmony default export */ var manage_preset_search = (SearchInput);

// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(25934);
// EXTERNAL MODULE: ./node_modules/clipboard/dist/clipboard.js
var clipboard = __webpack_require__(42152);
var clipboard_default = /*#__PURE__*/__webpack_require__.n(clipboard);
// EXTERNAL MODULE: ./src/theme/input/index.js
var theme_input = __webpack_require__(18744);
;// CONCATENATED MODULE: ./src/theme/popup/index.js

function popup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    opacity: 0;\n    transform: translate3d(0px, 45px, 0px);\n  }\n\n  100% {\n    opacity: 0.9;\n    transform: translate3d(0px, 0px, 0px);\n  }\n"
    ]);
    popup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function popup_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    opacity: 0.9;\n    transform: translate3d(0px, 0px, 0px);\n  }\n\n  100% {\n    opacity: 0;\n    transform: translate3d(0px, 45px, 0px);\n  }\n"
    ]);
    popup_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function popup_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 50px;\n  left: 0;\n  padding: 8px 12px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 4px;\n  font-size: 14px;\n  line-height: 100%;\n  text-align: center;\n  display: ",
        ";\n  opacity: ",
        ";\n  z-index: 999;\n\n  animation: ",
        " 0.3s linear 1;\n\n  ",
        "\n"
    ]);
    popup_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var fadeIn = (0,styled_components_browser_esm/* keyframes */.F4)(popup_templateObject());
var fadeOut = (0,styled_components_browser_esm/* keyframes */.F4)(popup_templateObject1());
var popup_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f76a7eb9-0"
})(popup_templateObject2(), function(param) {
    var visible = param.visible;
    return visible ? "flex" : "none";
}, function(param) {
    var out = param.out;
    return out ? 0 : 0.9;
}, function(param) {
    var out = param.out;
    return out ? fadeOut : fadeIn;
}, dist_index_esm/* color */.$_);
function PopUp(param) {
    var visible = param.visible, out = param.out, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popup_Wrapper, {
        bg: "grey_600",
        color: "white",
        visible: visible,
        out: out,
        children: children
    });
}
/* harmony default export */ var popup = (PopUp);

;// CONCATENATED MODULE: ./src/theme/icons/copy.js


function copy() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#copy-clip06654)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M17.6756 6.67178C17.6662 6.5891 17.6481 6.50765 17.6216 6.42878V6.34778C17.5783 6.25524 17.5206 6.17018 17.4506 6.09578L12.0506 0.695781C11.9762 0.625776 11.8911 0.568054 11.7986 0.524781C11.7717 0.520965 11.7445 0.520965 11.7176 0.524781C11.6262 0.472348 11.5252 0.438691 11.4206 0.425781H7.77559C7.0595 0.425781 6.37275 0.710245 5.8664 1.21659C5.36005 1.72294 5.07559 2.4097 5.07559 3.12578V4.02578H4.17559C3.4595 4.02578 2.77275 4.31024 2.2664 4.81659C1.76005 5.32294 1.47559 6.0097 1.47559 6.72578V15.7258C1.47559 16.4419 1.76005 17.1286 2.2664 17.635C2.77275 18.1413 3.4595 18.4258 4.17559 18.4258H11.3756C12.0917 18.4258 12.7784 18.1413 13.2848 17.635C13.7911 17.1286 14.0756 16.4419 14.0756 15.7258V14.8258H14.9756C15.6917 14.8258 16.3784 14.5413 16.8848 14.035C17.3911 13.5286 17.6756 12.8419 17.6756 12.1258V6.72578V6.67178ZM12.2756 3.49478L14.6066 5.82578H13.1756C12.9369 5.82578 12.708 5.73096 12.5392 5.56218C12.3704 5.39339 12.2756 5.16448 12.2756 4.92578V3.49478ZM12.2756 15.7258C12.2756 15.9645 12.1808 16.1934 12.012 16.3622C11.8432 16.531 11.6143 16.6258 11.3756 16.6258H4.17559C3.93689 16.6258 3.70797 16.531 3.53919 16.3622C3.37041 16.1934 3.27559 15.9645 3.27559 15.7258V6.72578C3.27559 6.48709 3.37041 6.25817 3.53919 6.08939C3.70797 5.9206 3.93689 5.82578 4.17559 5.82578H5.07559V12.1258C5.07559 12.8419 5.36005 13.5286 5.8664 14.035C6.37275 14.5413 7.0595 14.8258 7.77559 14.8258H12.2756V15.7258ZM15.8756 12.1258C15.8756 12.3645 15.7808 12.5934 15.612 12.7622C15.4432 12.931 15.2143 13.0258 14.9756 13.0258H7.77559C7.53689 13.0258 7.30797 12.931 7.13919 12.7622C6.97041 12.5934 6.87559 12.3645 6.87559 12.1258V3.12578C6.87559 2.88709 6.97041 2.65817 7.13919 2.48939C7.30797 2.3206 7.53689 2.22578 7.77559 2.22578H10.4756V4.92578C10.4756 5.64187 10.76 6.32862 11.2664 6.83497C11.7727 7.34132 12.4595 7.62578 13.1756 7.62578H15.8756V12.1258Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "copy-clip06654",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "translate(0.575195 0.425781)"
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/theme/icons/write.js
var write = __webpack_require__(54469);
;// CONCATENATED MODULE: ./src/theme/icons/bin.js


function bin() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        viewBox: "0 0 18 19",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#bin-clip665)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M6 0.36377V1.36377H1V3.36377H2V16.3638C2 17.4683 2.89543 18.3638 4 18.3638H14C15.1046 18.3638 16 17.4683 16 16.3638V3.36377H17V1.36377H12V0.36377H6ZM4 3.36377H14V16.3638H4V3.36377ZM6 5.36377V14.3638H8V5.36377H6ZM10 5.36377V14.3638H12V5.36377H10Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "bin-clip665",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M0 0.36377H18V18.3638H0V0.36377Z",
                        fill: "white"
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/filters/manage-preset/preset-item/index.js




function preset_item_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  height: 58px;\n\n  & > .btn-preset {\n    display: flex;\n    flex: 1;\n    align-items: center;\n  }\n"
    ]);
    preset_item_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function preset_item_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  height: ",
        "px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  /* stylelint-disable */\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  /* stylelint-enable */\n  -webkit-line-clamp: ",
        ";\n"
    ]);
    preset_item_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function preset_item_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n"
    ]);
    preset_item_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function preset_item_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  position: relative;\n  display: ",
        ";\n  width: 38px;\n  height: 38px;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    preset_item_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function preset_item_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    preset_item_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 18px;\n  height: 18px;\n  animation: ",
        " 2s linear infinite;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


















var preset_item_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3c3d81e-0"
})(preset_item_templateObject(), dist_index_esm/* space */.Dh);
var preset_item_TextEllipsis = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-f3c3d81e-1"
})(preset_item_templateObject1(), dist_index_esm/* typography */.cp, dist_index_esm/* color */.$_, dist_index_esm/* space */.Dh, function(param) {
    var line = param.line;
    return line * 22;
}, function(param) {
    var line = param.line;
    return line;
});
var ActionsWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3c3d81e-2"
})(preset_item_templateObject2());
var ButtonStyled = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-f3c3d81e-3"
})(preset_item_templateObject3(), dist_index_esm/* color */.$_, function(param) {
    var isHidden = param.isHidden;
    return isHidden ? "none" : "flex";
});
var preset_item_rotate = (0,styled_components_browser_esm/* keyframes */.F4)(preset_item_templateObject4());
var preset_item_WrapLoader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3c3d81e-4"
})(_templateObject5(), preset_item_rotate);
function PresetItem(param) {
    var languageCode = param.languageCode, error = param.error, isWaiting = param.isWaiting, payload = param.payload, onSelect = param.onSelect, onDelete = param.onDelete, onEdit = param.onEdit;
    var ref = (0,react.useRef)();
    var uuid = (0,react.useRef)((0,v4/* default */.Z)()).current;
    var ref1 = (0,react.useState)(false), visible = ref1[0], setVisible = ref1[1];
    var ref2 = (0,react.useState)(true), out = ref2[0], setOut = ref2[1];
    var ref3 = (0,react.useState)(false), touched = ref3[0], setTouched = ref3[1];
    var ref4 = (0,react.useState)(payload.title), titleInput = ref4[0], setTitleInput = ref4[1];
    var ref5 = (0,react.useState)(false), isEditable = ref5[0], setIsEditable = ref5[1];
    var otherFilter = (0,es/* useSelector */.v9)(config/* selectOtherFilter */.KJ);
    var analytics_type = (0,es/* useSelector */.v9)(function(state) {
        return state.profile.payload;
    }).analytics_type;
    (0,react.useEffect)(function() {
        var clip = new (clipboard_default())("#a".concat(uuid.replaceAll("-", "")));
        return function() {
            return clip.destroy();
        };
    }, [
        payload.title,
        uuid
    ]);
    var query = (0,react.useMemo)(function() {
        var compare = payload.compare, dataType = payload.dataType, dateFrom = payload.dateFrom, dateTo = payload.dateTo, dateRange = payload.dateRange, filters = payload.filters;
        if (!compare || !dataType || !dateFrom || !dateTo || !dateRange) return null;
        var queryString = "dateRange=".concat(dateRange, "&compare=").concat(compare, "&dateTo=").concat(dateTo, "&dateFrom=").concat(dateFrom, "&dataType=").concat(dataType, "&version=7&enterprise=").concat(analytics_type || "standard");
        if (filters) {
            queryString = "".concat(queryString, "&filters=").concat(filters);
        }
        return "".concat(window.location.href.split("?")[0], "?").concat(queryString);
    }, [
        payload,
        analytics_type
    ]);
    var formatDatesToCalendar = (0,react.useMemo)(function() {
        return [
            moment_default()(payload.dateFrom),
            moment_default()(payload.dateTo)
        ];
    }, [
        payload
    ]);
    var handleClick = (0,react.useCallback)(function() {
        var others = {};
        var filters = payload.filters;
        if (filters) {
            var splitedFilters = filters.split(",");
            splitedFilters.forEach(function(filter) {
                var splitedFilter = filter.split("=");
                if (splitedFilter.length !== 2) return;
                var ref = otherFilter.find(function(el) {
                    return el.value === splitedFilter[0];
                }), colorFilter = ref.color;
                others = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, others), (0,_define_property/* default */.Z)({}, JSON.stringify("".concat(splitedFilter[0], "-").concat(splitedFilter[1])), {
                    type: splitedFilter[0],
                    value: splitedFilter[1],
                    color: colorFilter
                }));
            });
        }
        var terms = {};
        var termsFilter = payload.terms;
        if (termsFilter) {
            var splitedFilters1 = termsFilter.split(",");
            splitedFilters1.forEach(function(filter) {
                var splitedFilter = filter.split("=");
                if (splitedFilter.length !== 2) return;
                var ref = otherFilter.find(function(el) {
                    return el.value === splitedFilter[0];
                }), colorFilter = ref.color;
                terms = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, terms), (0,_define_property/* default */.Z)({}, JSON.stringify("".concat(splitedFilter[0], "-").concat(splitedFilter[1])), {
                    type: splitedFilter[0],
                    value: splitedFilter[1],
                    color: colorFilter
                }));
            });
        }
        onSelect((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
            dates: formatDatesToCalendar,
            others: others,
            terms: terms
        }));
    }, [
        onSelect,
        payload,
        formatDatesToCalendar,
        otherFilter
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var delayedHandleChange = (0,react.useCallback)((0,lodash.debounce)(function(p) {
        var trimmedValue = p.trim();
        if (payload.title !== trimmedValue) {
            setTouched(true);
            onEdit(payload.title, trimmedValue);
        }
    }, 500), []);
    var handleChangeTitle = (0,react.useCallback)(function(e) {
        var value = e.target.value;
        setTitleInput(value);
        delayedHandleChange(value);
    }, [
        delayedHandleChange
    ]);
    var handleCopy = (0,react.useCallback)(function() {
        setOut(false);
        setVisible(true);
        setTimeout(function() {
            setOut(true);
        }, 3000);
    }, []);
    var handleDelete = (0,react.useCallback)(function() {
        onDelete(payload);
    }, [
        onDelete,
        payload
    ]);
    var handleEdit = (0,react.useCallback)(function() {
        setIsEditable(!isEditable);
    }, [
        isEditable
    ]);
    (0,hooks/* useOutsideClick */.O3)(ref, function() {
        if (isWaiting) return;
        setTouched(false);
        setTitleInput(payload.title);
        setIsEditable(false);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(preset_item_Wrapper, {
        my: "xxs",
        px: "xs",
        ref: ref,
        children: [
            !isEditable ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                title: payload.title,
                type: "button",
                className: "btn-preset",
                onClick: handleClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(preset_item_TextEllipsis, {
                    fontSize: "display",
                    lineHeight: "display",
                    fontWeight: "medium",
                    color: "grey_400",
                    line: "1",
                    children: payload.title
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_input/* default */.Z, {
                style: {
                    width: "100%"
                },
                meta: {
                    touched: touched,
                    error: error
                },
                input: {
                    onChange: handleChangeTitle,
                    value: titleInput
                },
                isWaiting: isWaiting,
                addonAfter: true,
                noError: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionsWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonStyled, {
                        title: translations/* default */.Z[languageCode].copy,
                        id: "a".concat(uuid.replaceAll("-", "")),
                        isHidden: isEditable,
                        type: "button",
                        "data-clipboard-action": "copy",
                        "data-clipboard-text": query,
                        color: "grey_400",
                        onClick: handleCopy,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(popup, {
                                visible: visible,
                                out: out,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: translations/* default */.Z[languageCode].copied
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(copy, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonStyled, {
                        title: translations/* default */.Z[languageCode].edit,
                        color: "grey_400",
                        isHidden: isEditable,
                        type: "button",
                        onClick: handleEdit,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(write/* default */.Z, {
                            color: "grey_400"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonStyled, {
                        title: translations/* default */.Z[languageCode].delete,
                        color: "grey_400",
                        type: "button",
                        onClick: handleDelete,
                        disabled: isWaiting,
                        children: isWaiting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(preset_item_WrapLoader, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {
                                width: 18
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(bin, {})
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var preset_item = (PresetItem);

;// CONCATENATED MODULE: ./src/components/filters/manage-preset/index.js



function manage_preset_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  & > .presets-list {\n    width: 100%;\n    padding-top: ",
        "px;\n\n    & > .preset-wrap {\n      width: 100%;\n      border-bottom: 2px solid ",
        ";\n    }\n\n    & > .preset-wrap:last-child {\n      border-bottom: none;\n    }\n  }\n"
    ]);
    manage_preset_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var manage_preset_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-75767f2e-0"
})(manage_preset_templateObject(), (0,theme_get_dist_index_esm/* themeGet */.R)("space.m"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_50"));
function ManagePreset(param) {
    var isVisible = param.isVisible, onClose = param.onClose, languageCode = param.languageCode;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(""), searchInput = ref[0], setSearchInput = ref[1];
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        return state.preset;
    }), isWaiting = ref1.isWaiting, error = ref1.error;
    var payload = (0,es/* useSelector */.v9)(reselect_preset);
    (0,react.useEffect)(function() {
        dispatch((0,preset/* getPresetRequest */.Pc)());
    }, [
        dispatch
    ]);
    var presets = (0,react.useMemo)(function() {
        if (!payload.presets) return [];
        return payload.presets.filter(function(preset) {
            return preset.title.toLowerCase().includes(searchInput.toLowerCase());
        });
    }, [
        payload,
        searchInput
    ]);
    var handleSelect = (0,react.useCallback)(function(p) {
        onClose();
        dispatch((0,action_filters/* changeFilters */.P7)(p));
    }, [
        dispatch,
        onClose
    ]);
    var handleEdit = (0,react.useCallback)(function(title, changedTitle) {
        dispatch((0,preset/* putPresetRequest */.HT)({
            presetId: title,
            preset: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
                title: changedTitle
            })
        }));
    }, [
        dispatch,
        payload
    ]);
    var handleDelete = (0,react.useCallback)(function(p) {
        dispatch((0,preset/* delPresetRequest */.lP)(p.title));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
        isVisible: isVisible,
        onClose: onClose,
        title: translations/* default */.Z[languageCode]["manage preset"],
        bgColor: "white",
        width: "480px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(manage_preset_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(manage_preset_search, {
                    placeholder: translations/* default */.Z[languageCode].search,
                    value: searchInput,
                    onChange: setSearchInput
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "presets-list",
                    children: presets.map(function(preset) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "preset-wrap",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(preset_item, {
                                languageCode: languageCode,
                                payload: preset,
                                onSelect: handleSelect,
                                onEdit: handleEdit,
                                onDelete: handleDelete,
                                isWaiting: isWaiting,
                                error: error
                            })
                        }, preset.title);
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var manage_preset = (ManagePreset);

;// CONCATENATED MODULE: ./src/theme/icons/warning.js


function warning() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "19",
        height: "19",
        viewBox: "0 0 19 19",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.5752 16.1758C13.3031 16.1758 16.3252 13.1537 16.3252 9.42578C16.3252 5.69786 13.3031 2.67578 9.5752 2.67578C5.84727 2.67578 2.8252 5.69786 2.8252 9.42578C2.8252 13.1537 5.84727 16.1758 9.5752 16.1758Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.5752 6.05078V9.98828",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.5752 13.3633C10.0412 13.3633 10.4189 12.9855 10.4189 12.5195C10.4189 12.0535 10.0412 11.6758 9.5752 11.6758C9.10921 11.6758 8.73145 12.0535 8.73145 12.5195C8.73145 12.9855 9.10921 13.3633 9.5752 13.3633Z",
                fill: "currentColor"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/filters/save-preset/index.js

function save_preset_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  & > .row {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n  }\n\n  & > .wrap-error {\n    display: flex;\n    flex-direction: row;\n    color: ",
        ";\n    min-height: 20px;\n    margin-bottom: 4px;\n  }\n"
    ]);
    save_preset_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var save_preset_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-687bc4ee-0"
})(save_preset_templateObject(), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.red_400"));
function SavePreset(param) {
    var isVisible = param.isVisible, onClose = param.onClose, languageCode = param.languageCode;
    var dispatch = (0,es/* useDispatch */.I0)();
    var isWaiting = (0,es/* useSelector */.v9)(function(state) {
        return state.preset;
    }).isWaiting;
    var ref = (0,es/* useSelector */.v9)(reselect_filters/* default */.Z), compare = ref.compare, dataType = ref.dataType, dateRange = ref.dateRange, dateTo = ref.dateTo, dateFrom = ref.dateFrom, filters = ref.filters, terms = ref.terms, filtersData = ref.filtersData, termsData = ref.termsData;
    var ref1 = (0,react.useState)(""), title = ref1[0], setTitle = ref1[1];
    var ref2 = (0,react.useState)(false), error = ref2[0], setError = ref2[1];
    var handleChange = (0,react.useCallback)(function(e) {
        setTitle(e.target.value);
        setError(false);
    }, []);
    var handleSave = (0,react.useCallback)(function() {
        setError(false);
        if (title.length > 0) {
            dispatch((0,preset/* addPresetRequest */.SH)({
                preset: {
                    compare: compare,
                    dataType: dataType,
                    dateRange: dateRange,
                    dateTo: dateTo,
                    dateFrom: dateFrom,
                    filters: filters,
                    terms: terms,
                    title: title,
                    filtersData: filtersData,
                    termsData: termsData
                },
                onError: function() {
                    setError(true);
                },
                onSave: function() {
                    onClose();
                    setTitle("");
                    setError(false);
                }
            }));
        }
    }, [
        onClose,
        dispatch,
        compare,
        dataType,
        dateRange,
        dateTo,
        dateFrom,
        filters,
        terms,
        filtersData,
        termsData,
        title, 
    ]);
    var handleCancel = (0,react.useCallback)(function() {
        setTitle("");
        onClose();
        setError(false);
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
        width: "480px",
        isVisible: isVisible,
        onClose: onClose,
        title: translations/* default */.Z[languageCode]["save preset"],
        bgColor: "white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(save_preset_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                    color: "grey_600",
                    fontSize: "display",
                    lineHeight: "display",
                    fontWeight: "medium",
                    mb: "xxs",
                    children: translations/* default */.Z[languageCode].title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_input/* default */.Z, {
                    style: {
                        pb: "xs"
                    },
                    meta: {},
                    input: {
                        onChange: handleChange,
                        value: title
                    },
                    noError: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "wrap-error",
                    children: error ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(warning, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: "display",
                                lineHeight: "display",
                                fontWeight: "medium",
                                ml: "xxs",
                                color: "red_400",
                                children: translations/* default */.Z[languageCode]["duplicate error"]
                            })
                        ]
                    }) : null
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(btn_border/* default */.Z, {
                            onClick: handleCancel,
                            style: {
                                width: "100%",
                                maxWidth: "110px",
                                minWidth: "110px",
                                height: "48px",
                                mr: "s",
                                p: 0
                            },
                            type: "button",
                            label: translations/* default */.Z[languageCode].cancel
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(btn/* default */.Z, {
                            onClick: handleSave,
                            style: {
                                width: "100%",
                                maxWidth: "110px",
                                minWidth: "110px",
                                height: "48px",
                                p: 0
                            },
                            isWaiting: isWaiting,
                            type: "button",
                            label: translations/* default */.Z[languageCode].save
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var save_preset = (SavePreset);

// EXTERNAL MODULE: ./src/theme/icons/close.js
var icons_close = __webpack_require__(5842);
;// CONCATENATED MODULE: ./src/components/filters/tag/index.js
/* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/no-static-element-interactions */ 
function tag_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: row;\n  width: fit-content;\n  height: 38px;\n  border: 2px solid ",
        ";\n  border-radius: 4px;\n  background-color: ",
        ";\n  align-items: center;\n\n  & > .tag-label {\n    ",
        "\n\n    width: 8px;\n    height: 100%;\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n  }\n\n  & > .tag-body {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 0 0 0 ",
        "px;\n    flex: 1;\n  }\n\n  & > .tag-close {\n    cursor: pointer;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    width: 38px;\n    height: 100%;\n  }\n"
    ]);
    tag_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function tag_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: bold;\n  font-size: 9px;\n  text-transform: uppercase;\n  padding: 2px 6px;\n  border-radius: 3px;\n  cursor: pointer;\n  user-select: none;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  line-height: 1;\n  margin-left: ",
        "px;\n  \n  &:hover {\n    background-color: ",
        ";\n    border-color: ",
        ";\n  }\n"
    ]);
    tag_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var tag_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e5ec9dbd-0"
})(tag_templateObject(), dist_index_esm/* space */.Dh, (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_100"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.white"), dist_index_esm/* color */.$_, (0,theme_get_dist_index_esm/* themeGet */.R)("space.s"));
var NotButton = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e5ec9dbd-1"
})(tag_templateObject1(), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.red_400"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.red_50"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.red_200"), (0,theme_get_dist_index_esm/* themeGet */.R)("space.xs"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.red_100"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.red_300"));
function Tag(param) {
    var tagId = param.tagId, labelColor = param.labelColor, labelTitle = param.labelTitle, value = param.value, onDelete = param.onDelete, _isExclusive = param.isExclusive, isExclusive = _isExclusive === void 0 ? false : _isExclusive, onToggleExclusive = param.onToggleExclusive;
    var handleDelete = (0,react.useCallback)(function() {
        onDelete(tagId);
    }, [
        tagId,
        onDelete
    ]);
    var handleToggleExclusive = (0,react.useCallback)(function() {
        if (onToggleExclusive) {
            onToggleExclusive(tagId);
        }
    }, [
        tagId,
        onToggleExclusive
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(tag_Wrapper, {
        mr: "xs",
        mb: "xs",
        bg: labelColor,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tag-label"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tag-body",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                        fontSize: "display",
                        lineHeight: "display",
                        fontWeight: "bold",
                        color: "grey_600",
                        mr: "xxs",
                        children: "".concat(isExclusive ? "NOT " : "").concat(labelTitle, ": ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                        fontSize: "h3",
                        lineHeight: "h3",
                        fontWeight: "normal",
                        color: "grey_400",
                        children: value
                    }),
                    !isExclusive && onToggleExclusive && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotButton, {
                        onClick: handleToggleExclusive,
                        children: "NOT"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tag-close",
                onClick: handleDelete,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_close/* default */.Z, {})
            })
        ]
    });
}
/* harmony default export */ var tag = (Tag);

;// CONCATENATED MODULE: ./src/components/filters/index.js




function filters_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        "px ",
        "px 0;\n\n  @media (min-width: ",
        ") {\n    padding: ",
        "px ",
        "px 0;\n  }\n\n  position: ",
        ";\n  z-index: ",
        ";\n  background: ",
        ";\n  min-height: ",
        ";\n  padding-bottom: ",
        ";\n  top: ",
        ";\n  border-bottom: ",
        ";\n\n  & > .row {\n    display: flex;\n    /* On a phone the two halves are one under the other and every control\n       wraps: side by side, the buttons ran off the right edge of the screen. */\n    flex-direction: column;\n    justify-content: space-between;\n\n    & > div {\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n      align-items: center;\n      justify-content: flex-start;\n      gap: ",
        "px;\n    }\n\n    & > .left {\n      flex: 1;\n    }\n\n    & > .right {\n      align-items: flex-start;\n    }\n\n    @media (min-width: ",
        ") {\n      flex-direction: row;\n\n      & > div {\n        flex-wrap: nowrap;\n        gap: 0;\n      }\n    }\n  }\n"
    ]);
    filters_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function filters_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  @media (min-width: ",
        ") {\n    display: block;\n  }\n"
    ]);
    filters_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function filters_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex: 1;\n\n  & > .column {\n    display: flex;\n    flex-direction: column;\n    margin-right: ",
        "px;\n\n    & > .flex {\n      display: flex;\n      align-items: center;\n    }\n  }\n"
    ]);
    filters_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function filters_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n"
    ]);
    filters_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function filters_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  display: ",
        ";\n\n  width: 250px;\n  position: absolute;\n  right: 30px;\n  margin-top: 54px;\n  border: 1px solid;\n  border-radius: 12px;\n  z-index: 999;\n  overflow: hidden;\n\n  ",
        "\n\n  & > ul {\n    width: 100%;\n    margin: 0;\n    padding: 0;\n\n    & > li {\n      width: 100%;\n      height: 54px;\n      list-style-type: none;\n      display: flex;\n      padding: 0 8px;\n      box-shadow: inset 0px -1px 0px ",
        ";\n\n      &:hover {\n        box-shadow: inset 0px -2px 0px ",
        ";\n      }\n\n      &:active {\n        box-shadow: inset 0px -4px 0px ",
        ";\n      }\n    }\n  }\n"
    ]);
    filters_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function filters_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  & > span {\n    justify-content: flex-start;\n  }\n"
    ]);
    filters_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  padding: 0 ",
        "px;\n  min-height: 54px;\n\n  & > span {\n    justify-content: flex-start;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: none;\n  color: ",
        ";\n  margin-left: ",
        "px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}






























var filters_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9cbe3871-0"
})(filters_templateObject(), (0,theme_get_dist_index_esm/* themeGet */.R)("space.m"), (0,theme_get_dist_index_esm/* themeGet */.R)("space.s"), (0,theme_get_dist_index_esm/* themeGet */.R)("breakpoints.0"), (0,theme_get_dist_index_esm/* themeGet */.R)("space.l"), (0,theme_get_dist_index_esm/* themeGet */.R)("space.l"), function(param) {
    var isFixed = param.isFixed;
    return isFixed ? "fixed" : "initial";
}, function(param) {
    var isFixed = param.isFixed;
    return isFixed ? 1 : "initial";
}, function(param) {
    var isFixed = param.isFixed;
    return isFixed ? "white" : "initial";
}, function(param) {
    var isFixed = param.isFixed;
    return isFixed ? "110px" : "initial";
}, function(param) {
    var isFixed = param.isFixed;
    return isFixed ? "10px !important" : "initial";
}, function(param) {
    var isFixed = param.isFixed;
    return isFixed ? 0 : "initial";
}, function(param) {
    var isFixed = param.isFixed;
    return isFixed ? "1px solid #0a8ea0" : "initial";
}, (0,theme_get_dist_index_esm/* themeGet */.R)("space.xs"), (0,theme_get_dist_index_esm/* themeGet */.R)("breakpoints.0"));
/* The period line and the explanation of what the charts show: useful on a
   desktop, three quarters of a phone screen before the first number. */ var OnlyWide = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9cbe3871-1"
})(filters_templateObject1(), (0,theme_get_dist_index_esm/* themeGet */.R)("breakpoints.0"));
var ButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9cbe3871-2"
})(filters_templateObject2(), (0,theme_get_dist_index_esm/* themeGet */.R)("space.s"));
var FilterTags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9cbe3871-3"
})(filters_templateObject3(), dist_index_esm/* space */.Dh);
var filters_Menu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9cbe3871-4"
})(filters_templateObject4(), dist_index_esm/* space */.Dh, dist_index_esm/* color */.$_, function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "block" : "none";
}, dist_index_esm/* border */.Cg, (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_100"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_200"), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_500"));
var StyledBtnGhost = (0,styled_components_browser_esm/* default */.ZP)(ghost/* default */.Z).withConfig({
    componentId: "sc-9cbe3871-5"
})(filters_templateObject5());
var StyledDivGhost = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9cbe3871-6"
})(_templateObject6(), (0,theme_get_dist_index_esm/* themeGet */.R)("space.xs"));
var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-9cbe3871-7"
})(_templateObject7(), (0,theme_get_dist_index_esm/* themeGet */.R)("colors.primary_400"), (0,theme_get_dist_index_esm/* themeGet */.R)("space.xxs"));
function Filters(param) {
    var noShowCompare = param.noShowCompare, noReload = param.noReload;
    var ref = (0,router.useRouter)(), pathname = ref.pathname, query = ref.query, push = ref.push;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react.useRef)();
    var ref2 = (0,react.useState)(false), isOpenMoreFilters = ref2[0], setOpenMoreFilters = ref2[1];
    var ref3 = (0,react.useState)(false), isManagePresetVisible = ref3[0], setManagePresetVisible = ref3[1];
    var ref4 = (0,react.useState)(false), isSavePresetVisible = ref4[0], setSavePresetVisible = ref4[1];
    var ref5 = (0,react.useState)(false), isFixed = ref5[0], setIsFixed = ref5[1];
    var ref6 = (0,react.useState)(false), isOpen = ref6[0], setOpen = ref6[1];
    (0,hooks/* useOutsideClick */.O3)(ref1, function() {
        setOpen(false);
    });
    var handleScroll = function() {
        var offset = window.scrollY;
        var fixedPosition = 240;
        var minHeight = 900;
        // The theme's first breakpoint. Below it the page already has a sticky bar
        // of its own, and a second one 110px tall — on a screen this narrow — buried
        // the page under its own chrome.
        var minWidth = 921;
        if (offset > fixedPosition && window.innerHeight > minHeight && window.innerWidth >= minWidth) {
            setIsFixed(true);
        } else {
            setIsFixed(false);
        }
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        // Rotating a phone changes both measurements, and without this the bar
        // stayed in whatever state the last scroll left it in.
        window.addEventListener("resize", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleScroll);
        };
    }, []);
    var ref7 = (0,es/* useSelector */.v9)(profile/* default */.Z), isAdminAnalytics = ref7.isAdminAnalytics, analytics_type = ref7.payload.analytics_type;
    var ref8 = (0,es/* useSelector */.v9)(function(state) {
        return state.filters;
    }), compare = ref8.compare, dateRange = ref8.dateRange, dates = ref8.dates, others = ref8.others, terms = ref8.terms, includeRepartitionCharge = ref8.includeRepartitionCharge;
    var ref9 = (0,es/* useSelector */.v9)(reselect_filters/* default */.Z), dataType = ref9.dataType, isChanged = ref9.isChanged, dateTo = ref9.dateTo, dateFrom = ref9.dateFrom, filters = ref9.filters, termsFilter = ref9.terms, filtersData = ref9.filtersData, termsData = ref9.termsData;
    var ref10 = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }), languageCode = ref10.languageCode, formatDate = ref10.formatDate;
    var selectByFilter = (0,es/* useSelector */.v9)(config/* selectByFiler */.eB);
    var otherFilter = (0,es/* useSelector */.v9)(config/* selectOtherFilter */.KJ);
    (0,react.useEffect)(function() {
        var isQuery = Object.keys(query).length > 0;
        if (!query.accessToken && isQuery && !isChanged) {
            var parsedQuery = filters_from_query(query);
            var dateFromQuery = parsedQuery.dateFrom, dateToQuery = parsedQuery.dateTo, othersParsed = parsedQuery.others, termsParsed = parsedQuery.terms;
            var parsedDateToQuery = dateToQuery;
            if (moment_default()(dateToQuery, formatDate).isAfter(moment_default()())) {
                parsedDateToQuery = moment_default()().format(formatDate);
            }
            dispatch((0,action_filters/* changeFilters */.P7)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, parsedQuery), {
                dates: [
                    moment_default()(dateFromQuery, formatDate),
                    moment_default()(parsedDateToQuery, formatDate)
                ],
                others: othersParsed,
                terms: termsParsed
            })));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        if (isChanged) {
            push({
                pathname: pathname,
                query: {
                    compare: encodeURI(compare),
                    dataType: encodeURI(dataType),
                    dateRange: encodeURI(dateRange),
                    dateFrom: encodeURI(dateFrom),
                    dateTo: encodeURI(dateTo),
                    filters: encodeURI(filters),
                    terms: encodeURI(termsFilter),
                    filtersData: encodeURI(filtersData),
                    termsData: encodeURI(termsData)
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isChanged,
        filters,
        termsFilter,
        dateTo,
        dateFrom,
        compare,
        dataType,
        dateRange
    ]);
    var ref11 = (0,es/* useSelector */.v9)(function(state) {
        return state.filters;
    }), _compareTo = ref11.compareTo, dateFromCompare = _compareTo.dateFrom, dateToCompare = _compareTo.dateTo;
    (0,react.useEffect)(function() {
        if (noShowCompare) return;
        dispatch((0,action_filters/* comparedToRequest */.v8)({
            compare: compare,
            dateFrom: moment_default()(dateFrom).format(formatDate),
            dateTo: moment_default()(dateTo).format(formatDate),
            dateRange: dateRange
        }));
    }, [
        noShowCompare,
        formatDate,
        dateFrom,
        dateTo,
        dispatch,
        compare,
        dateRange
    ]);
    var formatComparedDates = (0,react.useMemo)(function() {
        if (noShowCompare) return null;
        moment_default().locale(languageCode);
        if (!dateFromCompare || !dateToCompare) return null;
        return {
            dateFrom: moment_default()(dateFromCompare).format("DD MMM YYYY"),
            dateTo: moment_default()(dateToCompare).format("DD MMM YYYY")
        };
    }, [
        noShowCompare,
        dateFromCompare,
        dateToCompare,
        languageCode
    ]);
    var handleReset = (0,react.useCallback)(function() {
        push({
            pathname: pathname,
            query: {}
        });
        dispatch((0,action_filters/* resetFilters */.aw)());
    }, [
        dispatch,
        push,
        pathname
    ]);
    var handleOpenMoreFilters = (0,react.useCallback)(function() {
        setOpenMoreFilters(!isOpenMoreFilters);
    }, [
        isOpenMoreFilters
    ]);
    var handlePreset = (0,react.useCallback)(function() {
        setManagePresetVisible(true);
    }, []);
    var handleCloseManagePreset = (0,react.useCallback)(function() {
        setManagePresetVisible(false);
    }, []);
    var handleSavePreset = (0,react.useCallback)(function() {
        setSavePresetVisible(true);
    }, []);
    var handleCloseSavePreset = (0,react.useCallback)(function() {
        setSavePresetVisible(false);
    }, []);
    var handleChangeOtherFilter = (0,react.useCallback)(function(type, label, value, filterColor) {
        var isExclusive = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        var filtersCopy = (0,_object_spread/* default */.Z)({}, others);
        if (type === "isbn" && value.trim().match(/.* .*/)) {
            var isbnValue = value.split("=")[1];
            var isbns = isbnValue.split(" ");
            isbns.forEach(function(isbn) {
                filtersCopy[JSON.stringify("".concat(type, "-").concat(isbn))] = {
                    type: type,
                    label: isbn,
                    value: "isbn=".concat(isbn),
                    color: filterColor,
                    isExclusive: isExclusive
                };
            });
        } else {
            filtersCopy[JSON.stringify("".concat(type, "-").concat(value))] = {
                type: type,
                label: label,
                value: value,
                color: filterColor,
                isExclusive: isExclusive
            };
        }
        dispatch((0,action_filters/* changeOthersFilter */.Ao)(filtersCopy));
    }, [
        dispatch,
        others
    ]);
    var handleChangeTermFilter = (0,react.useCallback)(function(type, label, value, filterColor) {
        var isExclusive = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        dispatch((0,action_filters/* changeTermsFilter */.QI)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, terms), (0,_define_property/* default */.Z)({}, JSON.stringify("".concat(type, "-").concat(value)), {
            type: type,
            label: label,
            value: value,
            color: filterColor,
            isExclusive: isExclusive
        }))));
    }, [
        dispatch,
        terms
    ]);
    var handleDelete = (0,react.useCallback)(function(tagId) {
        var othersFilter = (0,_object_spread/* default */.Z)({}, others);
        delete othersFilter[tagId];
        dispatch((0,action_filters/* changeOthersFilter */.Ao)(othersFilter));
    }, [
        dispatch,
        others
    ]);
    var handleDeleteTerm = (0,react.useCallback)(function(tagId) {
        var termsF = (0,_object_spread/* default */.Z)({}, terms);
        delete termsF[tagId];
        dispatch((0,action_filters/* changeTermsFilter */.QI)(termsF));
    }, [
        dispatch,
        terms
    ]);
    var handleToggleExclusive = (0,react.useCallback)(function(tagId) {
        // Trovo il filtro da cambiare
        if (others[tagId]) {
            var filter = others[tagId];
            var filtersCopy = (0,_object_spread/* default */.Z)({}, others);
            // Cambio lo stato esclusivo
            filtersCopy[tagId] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filter), {
                isExclusive: !filter.isExclusive
            });
            dispatch((0,action_filters/* changeOthersFilter */.Ao)(filtersCopy));
        } else if (terms[tagId]) {
            var term = terms[tagId];
            var termsCopy = (0,_object_spread/* default */.Z)({}, terms);
            // Cambio lo stato esclusivo
            termsCopy[tagId] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, term), {
                isExclusive: !term.isExclusive
            });
            dispatch((0,action_filters/* changeTermsFilter */.QI)(termsCopy));
        }
    }, [
        dispatch,
        others,
        terms
    ]);
    var handleReload = (0,react.useCallback)(function() {
        dispatch((0,action_filters/* reloadFilters */.ps)());
    }, [
        dispatch
    ]);
    var handleChangeDataType = (0,react.useCallback)(function(payload) {
        dispatch((0,action_filters/* changeDataTypeFilter */.u2)(payload));
    }, [
        dispatch
    ]);
    var handleClickOptions = (0,react.useCallback)(function() {
        setOpen(!isOpen);
    }, [
        isOpen
    ]);
    var handleRepartitionChargeChange = (0,react.useCallback)(function(checked) {
        dispatch((0,action_filters/* changeFilters */.P7)({
            includeRepartitionCharge: checked
        }));
    }, [
        dispatch
    ]);
    var getDataTypeColor = (0,react.useCallback)(function(type) {
        if (type === "usage_data") return "pie_2_0";
        if (type === "aggregated_data" || type === "temporary_data") return "area_1";
        return "area_0";
    }, []);
    var getDataTypeText = (0,react.useCallback)(function(type, lang) {
        if (type === "aggregated_data") return translations/* default */.Z[lang].aggregated;
        if (type === "usage_data") return translations/* default */.Z[lang].usagedata;
        if (type === "temporary_data") return translations/* default */.Z[lang].trend_revenues;
        return translations/* default */.Z[lang].earning;
    }, []);
    var getTooltipText = (0,react.useCallback)(function(type, lang) {
        if (type === "usage_data") return translations/* default */.Z[lang]["tooltip.usage_data"];
        if (type === "aggregated_data") return translations/* default */.Z[lang]["tooltip.aggregated_data"];
        return translations/* default */.Z[lang]["tooltip.confirmed_data"];
    }, []);
    var getHelpText = (0,react.useCallback)(function(type, lang) {
        if (type === "aggregated_data") return translations/* default */.Z[lang].help_aggregated;
        if (type === "temporary_data") return translations/* default */.Z[lang].help_trend;
        return translations/* default */.Z[lang].help_confirmed;
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(filters_Wrapper, {
        isFixed: isFixed,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "left",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
                            children: !noShowCompare && formatComparedDates && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                                fontSize: "h3",
                                                lineHeight: "h3",
                                                fontWeight: "bold",
                                                mr: "xs",
                                                color: getDataTypeColor(dataType),
                                                children: getDataTypeText(dataType, languageCode)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdHelpOutline */.$x8, {
                                                "data-tip": true,
                                                "data-for": "help_data",
                                                size: "1.2em",
                                                color: "grey_400"
                                            }),
                                            isAdminAnalytics && /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineAdminPanelSettings */.Tbc, {
                                                size: "1.6em",
                                                color: "red"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OnlyWide, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                            fontSize: "label",
                                            lineHeight: "label",
                                            fontWeight: "normal",
                                            color: "grey_400",
                                            children: "".concat(translations/* default */.Z[languageCode].period, " ").concat(moment_default()(dates[0]).format("DD MMM YYYY"), " - ").concat(moment_default()(dates[1]).format("DD MMM YYYY"), " ").concat(translations/* default */.Z[languageCode]["compared to"], " ").concat(formatComparedDates.dateFrom, " - ").concat(formatComparedDates.dateTo)
                                        })
                                    }),
                                    dataType !== "usage_data" && /*#__PURE__*/ (0,jsx_runtime.jsx)(OnlyWide, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(theme_text/* default */.Z, {
                                            fontSize: "label",
                                            lineHeight: "label",
                                            fontWeight: "normal",
                                            color: "grey_400",
                                            children: [
                                                "".concat(getHelpText(dataType, languageCode)),
                                                dataType !== "usage_data" && !(analytics_type === null || analytics_type === void 0 ? void 0 : analytics_type.match(/split/i)) && (analytics_type === null || analytics_type === void 0 ? void 0 : analytics_type.match(/enterprise/i)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                                                    onClick: function() {
                                                        return handleChangeDataType(dataType === "real_data" ? "aggregated_data" : "real_data");
                                                    },
                                                    children: "".concat(dataType === "aggregated_data" ? translations/* default */.Z[languageCode].switchToConfirmed : translations/* default */.Z[languageCode].switchToAggregated)
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                                        forData: "help_data",
                                        text: getTooltipText(dataType, languageCode),
                                        arrowColor: "#098EA0",
                                        backgroundColor: "#098EA0",
                                        place: "right",
                                        effect: "solid",
                                        html: true
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "right",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(date_selector, {
                                noShowCompare: noShowCompare,
                                dates: dates,
                                selectByFilter: selectByFilter,
                                languageCode: languageCode,
                                dateRange: dateRange,
                                dataType: dataType,
                                compare: compare,
                                direction: "right"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(btn_border/* default */.Z, {
                                onClick: handleOpenMoreFilters,
                                style: {
                                    minWidth: "48px",
                                    height: "48px",
                                    p: 0,
                                    mr: "s",
                                    color: isOpenMoreFilters ? "white" : "primary_300",
                                    backgroundColor: isOpenMoreFilters ? "primary_300" : "transparent"
                                },
                                type: "button",
                                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_tune, {}),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                marginLeft: "10px"
                                            },
                                            children: "Filter results"
                                        })
                                    ]
                                }),
                                title: isOpenMoreFilters ? "Close extra filters" : "Open extra filters"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(btn_border/* default */.Z, {
                                onClick: handleClickOptions,
                                style: {
                                    minWidth: "48px",
                                    height: "48px",
                                    p: 0,
                                    color: "primary_300"
                                },
                                type: "button",
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(options/* default */.Z, {}),
                                title: "Analytics options"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(filters_Menu, {
                                ref: ref1,
                                direction: "right",
                                bg: "white",
                                isVisible: isOpen,
                                borderColor: "primary_200",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    children: [
                                        !noReload && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBtnGhost, {
                                                type: "button",
                                                onClick: function() {
                                                    handleReload();
                                                    setOpen(false);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(theme_text/* default */.Z, {
                                                    fontSize: "pLarge",
                                                    lineHeight: "pLarge",
                                                    fontWeight: "pLarge",
                                                    color: "grey_600",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(reload/* default */.Z, {}),
                                                        " ",
                                                        translations/* default */.Z[languageCode]["Reload data"]
                                                    ]
                                                })
                                            })
                                        }),
                                        isAdminAnalytics && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDivGhost, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(theme_text/* default */.Z, {
                                                        fontSize: "pLarge",
                                                        lineHeight: "pLarge",
                                                        fontWeight: "pLarge",
                                                        color: "grey_600",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineAdminPanelSettings */.Tbc, {}),
                                                            " ",
                                                            translations/* default */.Z[languageCode]["Include Repartition Charges"]
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_switch/* default */.Z, {
                                                        checked: includeRepartitionCharge,
                                                        onChange: function(checked) {
                                                            handleRepartitionChargeChange(checked);
                                                            setOpen(false);
                                                        },
                                                        size: "small",
                                                        style: {
                                                            marginLeft: "10px"
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBtnGhost, {
                                                type: "button",
                                                onClick: function() {
                                                    handlePreset();
                                                    setOpen(false);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(theme_text/* default */.Z, {
                                                    fontSize: "pLarge",
                                                    lineHeight: "pLarge",
                                                    fontWeight: "pLarge",
                                                    color: "grey_600",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* RiListSettingsLine */.dR_, {}),
                                                        " ",
                                                        translations/* default */.Z[languageCode]["manage preset"]
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBtnGhost, {
                                                type: "button",
                                                onClick: function() {
                                                    handleSavePreset();
                                                    setOpen(false);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(theme_text/* default */.Z, {
                                                    fontSize: "pLarge",
                                                    lineHeight: "pLarge",
                                                    fontWeight: "pLarge",
                                                    color: "grey_600",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdSave */.tfk, {}),
                                                        " ",
                                                        translations/* default */.Z[languageCode]["save preset"]
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(more_filters, {
                isOpen: isOpenMoreFilters,
                languageCode: languageCode,
                otherFilter: otherFilter,
                onChangeOtherFilter: handleChangeOtherFilter,
                onChangeTermFilter: handleChangeTermFilter,
                onReset: handleReset,
                dataType: dataType
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTags, {
                mt: "s",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        Object.keys(others).map(function(key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tag, {
                                tagId: key,
                                labelColor: others[key].color,
                                labelTitle: translations/* default */.Z[languageCode][others[key].type.split(".")[0]],
                                value: others[key].label,
                                onDelete: handleDelete,
                                isExclusive: others[key].isExclusive,
                                onToggleExclusive: handleToggleExclusive
                            }, key);
                        }),
                        Object.keys(terms).map(function(key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tag, {
                                tagId: key,
                                labelColor: terms[key].color,
                                labelTitle: translations/* default */.Z[languageCode][terms[key].type.split(".")[0]],
                                value: terms[key].label,
                                onDelete: handleDeleteTerm,
                                isExclusive: terms[key].isExclusive,
                                onToggleExclusive: handleToggleExclusive
                            }, key);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(manage_preset, {
                isVisible: isManagePresetVisible,
                onClose: handleCloseManagePreset,
                languageCode: languageCode
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(save_preset, {
                isVisible: isSavePresetVisible,
                onClose: handleCloseSavePreset,
                languageCode: languageCode
            })
        ]
    });
}
/* harmony default export */ var filters = (Filters);


/***/ }),

/***/ 32095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15313);
/* harmony import */ var redux_api_reselect_profile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95293);




function TopBar() {
    var languageCode = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.config;
    }).languageCode;
    var customerType = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(redux_api_reselect_profile__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).customerType;
    return languageCode === "REMOVED" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "sl-top-bar",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "sl-top-bar-container",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "sl-top-bar-content",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: "Su Ready sconto del 20% su tutti i servizi editoriali, approfittane subito! Promo valida fino a venerd\xec 18 novembre 2022"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "sl-top-bar-actions",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "https://readybooks.io",
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: "Vai su Ready"
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (TopBar);


/***/ }),

/***/ 42805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ warning_notification; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(32016);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js
var dist_index_esm = __webpack_require__(50056);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(15313);
// EXTERNAL MODULE: ./src/redux/action/warning.js
var warning = __webpack_require__(6482);
// EXTERNAL MODULE: ./src/redux/reselect/profile.js
var profile = __webpack_require__(95293);
// EXTERNAL MODULE: ./src/redux/reselect/warning.js
var reselect_warning = __webpack_require__(97998);
// EXTERNAL MODULE: ./src/theme/text/index.js
var theme_text = __webpack_require__(5799);
// EXTERNAL MODULE: ./src/theme/icons/alert.js
var icons_alert = __webpack_require__(88176);
;// CONCATENATED MODULE: ./src/theme/icons/hide.js


function Hide() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "15",
        viewBox: "0 0 16 15",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5.05475 7.50925L2.159 4.6135C1.019 5.85625 0.587 7.10125 0.5795 7.12675L0.5 7.36375L0.57875 7.60075C0.59525 7.651 2.31575 12.6137 8.0405 12.6137C8.73725 12.6137 9.37175 12.5372 9.9545 12.409L7.895 10.3495C7.15346 10.3131 6.45196 10.0022 5.92699 9.47726C5.40201 8.95228 5.0911 8.25078 5.05475 7.50925ZM8.0405 2.11375C6.64925 2.11375 5.50925 2.41675 4.559 2.86225L1.78025 0.0834961L0.71975 1.144L14.2197 14.644L15.2803 13.5835L12.8068 11.11C14.7853 9.64525 15.491 7.63225 15.5015 7.60075L15.5802 7.36375L15.5015 7.12675C15.485 7.0765 13.7653 2.11375 8.0405 2.11375ZM9.47 7.77324C9.61025 7.26549 9.491 6.694 9.101 6.30325C8.711 5.9125 8.13875 5.794 7.631 5.93425L6.5 4.80325C6.96347 4.51823 7.49641 4.36619 8.0405 4.36375C9.695 4.36375 11.0405 5.70925 11.0405 7.36375C11.0383 7.90773 10.8859 8.44055 10.6003 8.9035L9.47 7.77324Z",
            fill: "currentColor"
        })
    });
}
/* harmony default export */ var hide = (Hide);

// EXTERNAL MODULE: ./src/translations/index.js + 4 modules
var translations = __webpack_require__(99408);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/components/warning-notification/index.js



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: ",
        ";\n  width: 100%;\n  border-radius: 12px;\n\n  & > .head {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n\n    & > div {\n      display: flex;\n      flex-direction: row;\n    }\n\n    & > div > span {\n      color: ",
        ";\n    }\n  }\n\n  & > .notification {\n    border-radius: 4px;\n    border: 1px solid ",
        ";\n    background: ",
        ";\n    border-left: 4px solid ",
        ";\n    padding: ",
        "px;\n    margin: ",
        "px 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c4ef63db-0"
})(_templateObject(), index_esm/* space */.Dh, function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "block" : "none";
}, (0,dist_index_esm/* themeGet */.R)("colors.warning"), (0,dist_index_esm/* themeGet */.R)("colors.accent"), (0,dist_index_esm/* themeGet */.R)("colors.white"), (0,dist_index_esm/* themeGet */.R)("colors.warning"), (0,dist_index_esm/* themeGet */.R)("space.xs"), (0,dist_index_esm/* themeGet */.R)("space.xs"));
function WarningNotification(param) {
    var style = param.style, className = param.className;
    var dispatch = (0,es/* useDispatch */.I0)();
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var isVisible = (0,es/* useSelector */.v9)(function(state) {
        return state.warning;
    }).isVisible;
    var warnings = (0,es/* useSelector */.v9)(reselect_warning/* default */.Z);
    (0,react.useEffect)(function() {
        dispatch((0,warning/* getWarningRequest */.jT)());
    }, [
        dispatch
    ]);
    var handleClose = (0,react.useCallback)(function() {
        dispatch((0,warning/* setWarningVisible */.Ic)(false));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isVisible: isVisible && warnings.length
    }, style), {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "head",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_alert/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: "h4",
                                lineHeight: "h4",
                                fontWeight: "bold",
                                color: "grey_600",
                                ml: "10px",
                                children: translations/* default */.Z[languageCode].warning
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: translations/* default */.Z[languageCode].warning,
                        type: "button",
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hide, {})
                    })
                ]
            }),
            warnings.map(function(param) {
                var key = param.key, message = param.message;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "notification",
                    children: message
                }, key);
            })
        ]
    }));
}
/* harmony default export */ var warning_notification = (WarningNotification);


/***/ }),

/***/ 73559:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var ChangeCover = function(cover) {
    if (!cover) return cover;
    var changedCoverUrl = cover;
    if (changedCoverUrl.match(/^http:\/\/stealth-test-files/i)) {
        changedCoverUrl = changedCoverUrl.replace("http://stealth-test-files", "https://stealth-test-files.s3-eu-west-1.amazonaws.com");
    }
    var regexPublish = /^(http|https):\/\/storage.publish.streetlib.com(.s3.amazonaws.com|)/;
    if (changedCoverUrl.match(regexPublish)) {
        changedCoverUrl = changedCoverUrl.replace(regexPublish, "https://s3-publish.streetlib.com");
    }
    var regexSbf = /^(http|https):\/\/storage.sbfstealth.com(.s3.amazonaws.com|)/;
    if (changedCoverUrl.match(regexSbf)) {
        changedCoverUrl = changedCoverUrl.replace(regexSbf, "https://s3-publish.streetlib.com");
    }
    return changedCoverUrl;
};
/* harmony default export */ __webpack_exports__["Z"] = (ChangeCover);


/***/ }),

/***/ 45257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57708);
/* eslint-disable camelcase */ 






/* harmony default export */ __webpack_exports__["Z"] = ((0,reselect__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(function(state) {
    return state.filters;
}, function(state) {
    return state.profile;
}, _config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, function(payload, profile, param) {
    var formatDate = param.formatDate;
    var dates = payload.dates, others = payload.others, terms = payload.terms, dataType = payload.dataType, includeRepartitionCharge = payload.includeRepartitionCharge, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(payload, [
        "dates",
        "others",
        "terms",
        "dataType",
        "includeRepartitionCharge"
    ]);
    var analytics_type = profile.payload.analytics_type;
    // Funzione per pulire i dati e rimuovere riferimenti circolari
    // Only store type, label, color - value and isExclusive are derived from filters/terms
    var cleanFilterData = function(filter) {
        return {
            type: String(filter.type || ""),
            label: String(filter.label || ""),
            color: String(filter.color || "")
        };
    };
    // Estraggo tipo e valore da filter.value (es. "store_id=44"). Salto le entry
    // malformate o prive di value (può capitare con stati persistiti vecchi o
    // ricostruiti da query string) per evitare crash su .split di undefined.
    var buildFilterString = function(collection) {
        return Object.keys(collection).map(function(key) {
            var item = collection[key];
            if (!item || typeof item.value !== "string" || !item.value.includes("=")) return null;
            var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(item.value.split("="), 2), itemType = ref[0], itemValue = ref[1];
            var prefix = item.isExclusive ? "-" : "";
            return "".concat(itemType, "=").concat(prefix).concat(itemValue);
        }).filter(Boolean).join(",");
    };
    var othersToString = buildFilterString(others);
    var termsToString = buildFilterString(terms);
    var repartitionsFilter;
    var hasPublisher = Object.keys(others).some(function(key) {
        return key.includes("publisher");
    });
    if (hasPublisher) repartitionsFilter = "document_source_type=-repartition_credit";
    if (!includeRepartitionCharge) {
        repartitionsFilter = "document_source_type=-repartition_charge,document_source_type=-repartition_credit";
    }
    if (repartitionsFilter) {
        if (termsToString.length) termsToString = "".concat(termsToString, ",").concat(repartitionsFilter);
        else termsToString = repartitionsFilter;
    }
    // Pulisco i dati dei filtri per evitare problemi di serializzazione JSON
    var cleanFiltersData = Object.keys(others).reduce(function(acc, key) {
        try {
            acc[key] = cleanFilterData(others[key]);
        } catch (error) {
            // Se c'è un errore, creo un filtro pulito di fallback
            acc[key] = cleanFilterData({
                type: "unknown",
                label: "Unknown",
                color: "black"
            });
        }
        return acc;
    }, {});
    var cleanTermsData = Object.keys(terms).reduce(function(acc, key) {
        try {
            acc[key] = cleanFilterData(terms[key]);
        } catch (error) {
            // Se c'è un errore, creo un termine pulito di fallback
            acc[key] = cleanFilterData({
                type: "unknown",
                label: "Unknown",
                color: "black"
            });
        }
        return acc;
    }, {});
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        dataType: dataType === "aggregated_data" && (analytics_type === null || analytics_type === void 0 ? void 0 : analytics_type.match(/split/)) ? "temporary_data" : dataType,
        dateFrom: moment__WEBPACK_IMPORTED_MODULE_0___default()(dates[0]).format(formatDate),
        dateTo: moment__WEBPACK_IMPORTED_MODULE_0___default()(dates[1]).format(formatDate),
        filters: othersToString,
        terms: termsToString,
        filtersData: JSON.stringify(cleanFiltersData),
        termsData: JSON.stringify(cleanTermsData)
    });
}));


/***/ }),

/***/ 25733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32016);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50056);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14141);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 56px;\n  min-width: 140px;\n  background: transparent;\n  outline: 0;\n\n  & > span {\n    color: ",
        ";\n    border-radius: 12px;\n\n    padding: 0 ",
        "px;\n\n    width: 100%;\n    height: 100%;\n\n    ",
        "\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &:hover {\n      color: ",
        ";\n    }\n\n    &:focus {\n      color: ",
        ";\n    }\n\n    & > .icon-left {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-right: ",
        "px;\n    }\n  }\n\n  &:focus {\n    color: transparent;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Button = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-7a71ebf5-0"
})(_templateObject(), function(param) {
    var isFocused = param.isFocused;
    return isFocused ? (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_600") : (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_400");
}, (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("space.s"), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .typography */ .cp, (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_500"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_600"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("space.xs"), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .layout */ .bK);
function BtnLink(param) {
    var style = param.style, title = param.title, label = param.label, type = param.type, onClick = param.onClick, disabled = param.disabled, isWaiting = param.isWaiting, icon = param.icon, fontSize = param.fontSize, lineHeight = param.lineHeight, fontWeight = param.fontWeight;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Button, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        title: title || label,
        "aria-label": title || label,
        fontSize: fontSize || "h4",
        lineHeight: lineHeight || "h4",
        fontWeight: fontWeight || "bold"
    }, style), {
        type: type,
        disabled: disabled || isWaiting,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
            children: [
                icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    className: "icon-left",
                    children: icon
                }),
                label
            ]
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (BtnLink);


/***/ }),

/***/ 17227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32016);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50056);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14141);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: transparent;\n  outline: 0;\n  padding: 0;\n\n  & > span {\n    padding: ",
        "px;\n\n    width: 100%;\n    height: 100%;\n\n    ",
        "\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  &:focus {\n    background: transparent;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Button = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-fbde9e6-0"
})(_templateObject(), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("space.xs"), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .typography */ .cp, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .layout */ .bK);
function BtnGhost(param) {
    var style = param.style, className = param.className, children = param.children, type = param.type, onClick = param.onClick, disabled = param.disabled, isWaiting = param.isWaiting;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Button, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, style), {
        className: className,
        type: type,
        disabled: disabled || isWaiting,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
            children: children
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (BtnGhost);


/***/ }),

/***/ 8599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Filter(param) {
    var width = param.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width || "18",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip-filter-003477nfy)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M16.579 0.267578H1.42101C1.16975 0.267578 0.92878 0.367391 0.751113 0.545058C0.573446 0.722725 0.473633 0.963694 0.473633 1.21495V3.66866C0.473633 4.16413 0.675424 4.65109 1.02595 5.00162L6.15789 10.1335V17.3203C6.15807 17.4818 6.19945 17.6404 6.27811 17.7814C6.35676 17.9223 6.47009 18.0409 6.60736 18.1258C6.74463 18.2107 6.9013 18.2591 7.06254 18.2666C7.22378 18.274 7.38424 18.2402 7.52874 18.1682L11.3182 16.2735C11.6394 16.1124 11.8421 15.7846 11.8421 15.4256V10.1335L16.9741 5.00162C17.3246 4.65109 17.5264 4.16413 17.5264 3.66866V1.21495C17.5264 0.963694 17.4266 0.722725 17.2489 0.545058C17.0713 0.367391 16.8303 0.267578 16.579 0.267578ZM10.225 9.07154C10.1368 9.15937 10.0669 9.26376 10.0193 9.37871C9.97164 9.49367 9.94721 9.6169 9.94739 9.74134V14.8401L8.05264 15.7875V9.74134C8.05282 9.6169 8.02839 9.49367 7.98075 9.37871C7.93311 9.26376 7.8632 9.15937 7.77506 9.07154L2.36838 3.66866V2.16233H15.6326L15.6345 3.66203L10.225 9.07154Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip-filter-003477nfy",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "translate(0 0.267578)"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Filter);


/***/ }),

/***/ 16490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Reload(param) {
    var width = param.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width || "18",
        viewBox: "0 0 18 19",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14.3999 10.0089H17.3879L12.9329 14.4639L8.4779 10.0089H12.5729C12.5999 8.6229 12.0779 7.2459 11.0159 6.1839C8.9099 4.0779 5.4899 4.0779 3.3839 6.1839C1.2779 8.2899 1.2779 11.7189 3.3839 13.8249C5.0399 15.4809 7.5239 15.8319 9.5219 14.8779L10.8449 16.2009C8.0999 17.8299 4.4999 17.4699 2.1059 15.0939C-0.7021 12.2859 -0.6931 7.7319 2.1149 4.9239C4.9499 2.1069 9.4769 2.0979 12.2939 4.9149C13.6979 6.3189 14.3999 8.1639 14.3999 10.0089Z",
            fill: "currentColor"
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Reload);


/***/ }),

/***/ 54469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14141);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50056);
/* eslint-disable react-hooks/rules-of-hooks */ 



var write = function(param) {
    var disabled = param.disabled, _width = param.width, width = _width === void 0 ? "18" : _width, color = param.color;
    var theme = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(styled_components__WEBPACK_IMPORTED_MODULE_3__/* .ThemeContext */ .Ni);
    var colorMemo = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (color) {
            return (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_2__/* .themeGet */ .R)("colors.".concat(color))({
                theme: theme
            });
        }
        return disabled ? "grey_200" : (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_2__/* .themeGet */ .R)("colors.write")({
            theme: theme
        });
    }, [
        theme,
        disabled,
        color
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        viewBox: "0 0 18 19",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8.17702 13.8958L4.15285 13.9095V9.86981L12.938 1.16855C13.6219 0.485548 14.8247 0.4819 15.5141 1.17129L16.9603 2.61755C17.305 2.96224 17.4947 3.42001 17.4947 3.90696C17.4947 4.39391 17.305 4.85168 16.9603 5.19637L8.17702 13.8958ZM15.6737 3.90422L14.2247 2.4607L12.7711 3.90149L14.2174 5.34683L15.6737 3.90422ZM11.4753 5.1836L5.97663 10.6303V12.0793L7.4238 12.0748L12.9216 6.62986L11.4753 5.1836ZM15.0955 17.5452H2.32909C1.32328 17.5452 0.50531 16.7273 0.50531 15.7214V2.95499C0.50531 1.94917 1.32328 1.13121 2.32909 1.13121H10.3966L8.5728 2.95499H2.32909V15.7214H5.04561C5.06034 15.7219 5.07486 15.724 5.08927 15.726C5.1052 15.7283 5.121 15.7306 5.1368 15.7306C5.14865 15.7306 5.16074 15.7283 5.17282 15.726C5.1849 15.7237 5.19698 15.7214 5.20884 15.7214H15.0955V9.64096L16.9193 7.81718V15.7214C16.9193 16.7273 16.1014 17.5452 15.0955 17.5452Z",
                    fill: colorMemo
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "18",
                        height: "18",
                        fill: "white",
                        transform: "translate(0 0.100098)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (write);


/***/ }),

/***/ 66084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14141);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32016);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50056);
/* harmony import */ var theme_text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5799);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  border-bottom: 1px solid ",
        ";\n\n  ",
        "\n\n  & > a {\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 8px;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 2px;\n  height: 34px; /* Altezza adeguata per stare tra i bottoni */\n  background-color: ",
        ";\n  margin: 0 8px; /* Spazio tra gli elementi */\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c093c216-0"
})(_templateObject(), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_5__/* .themeGet */ .R)("colors.primary_200"), styled_system__WEBPACK_IMPORTED_MODULE_4__/* .space */ .Dh);
var TabBtn = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-c093c216-1"
})(_templateObject1(), styled_system__WEBPACK_IMPORTED_MODULE_4__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_4__/* .space */ .Dh);
var HorizontalDivider = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c093c216-2"
})(_templateObject2(), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_5__/* .themeGet */ .R)("colors.primary_200"));
function SubMenu(param) {
    var activeKey = param.activeKey, options = param.options;
    var isConfirmed = options.length > 0 && options[1].key === "confirmed";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        py: "s",
        px: "l",
        children: options.map(function(option, index) {
            var isSecondWithOnClick = index === 1 && option.onClick;
            var nextOptionExists = index < options.length - 1;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                children: [
                    !option.onClick ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: option.href,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            className: "link",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TabBtn, {
                                type: "button",
                                py: "s",
                                px: "m",
                                bg: activeKey === option.key ? "primary_100" : "transparent",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_text__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    fontSize: "h3",
                                    lineHeight: "h3",
                                    fontWeight: "medium",
                                    color: activeKey === option.key ? "primary_500" : option.color ? option.color : "grey_400",
                                    textAlign: "center",
                                    children: option.title
                                })
                            })
                        })
                    }, option.key) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TabBtn, {
                        type: "button",
                        py: "s",
                        px: "m",
                        bg: activeKey === option.key ? "primary_100" : (option === null || option === void 0 ? void 0 : option.bgColor) ? option === null || option === void 0 ? void 0 : option.bgColor : "transparent",
                        onClick: option.onClick,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_text__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            fontSize: "h3",
                            lineHeight: "h3",
                            fontWeight: "medium",
                            color: activeKey === option.key ? "primary_500" : (option === null || option === void 0 ? void 0 : option.color) ? option === null || option === void 0 ? void 0 : option.color : "grey_400",
                            textAlign: "center",
                            children: option.title
                        })
                    }),
                    isSecondWithOnClick && nextOptionExists && isConfirmed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HorizontalDivider, {})
                ]
            }, option.key);
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SubMenu);


/***/ }),

/***/ 4509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24762);






function CustomTooltip(_param) {
    var text = _param.text, forData = _param.forData, others = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "forData"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        id: forData,
        "aria-haspopup": "true"
    }, others), {
        children: text
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (CustomTooltip);


/***/ })

}]);